var items = {
  "block.minecraft.acacia_button": "Botón de acacia",
  "block.minecraft.acacia_door": "Puerta de acacia",
  "block.minecraft.acacia_fence": "Reja de acacia",
  "block.minecraft.acacia_fence_gate": "Portón de acacia",
  "block.minecraft.acacia_hanging_sign": "Cartel colgante de acacia",
  "block.minecraft.acacia_leaves": "Hojas de acacia",
  "block.minecraft.acacia_log": "Tronco de acacia",
  "block.minecraft.acacia_planks": "Madera de acacia",
  "block.minecraft.acacia_pressure_plate": "Placa de presión de acacia",
  "block.minecraft.acacia_sapling": "Brote de acacia",
  "block.minecraft.acacia_shelf": "Estante de acacia",
  "block.minecraft.acacia_sign": "Cartel de acacia",
  "block.minecraft.acacia_slab": "Baldosa de acacia",
  "block.minecraft.acacia_stairs": "Escaleras de acacia",
  "block.minecraft.acacia_trapdoor": "Escotilla de acacia",
  "block.minecraft.acacia_wall_hanging_sign": "Cartel colgante de acacia en pared",
  "block.minecraft.acacia_wall_sign": "Cartel de acacia en pared",
  "block.minecraft.acacia_wood": "Leño de acacia",
  "block.minecraft.activator_rail": "Vía activadora",
  "block.minecraft.air": "Aire",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Bloque de amatista",
  "block.minecraft.amethyst_cluster": "Clúster de amatista",
  "block.minecraft.ancient_debris": "Escombros ancestrales",
  "block.minecraft.andesite": "Andesita",
  "block.minecraft.andesite_slab": "Baldosa de andesita",
  "block.minecraft.andesite_stairs": "Escaleras de andesita",
  "block.minecraft.andesite_wall": "Pared de andesita",
  "block.minecraft.anvil": "Yunque",
  "block.minecraft.attached_melon_stem": "Tallo de sandía unido",
  "block.minecraft.attached_pumpkin_stem": "Tallo de zapallo unido",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Hojas de azalea",
  "block.minecraft.azure_bluet": "Rubiácea",
  "block.minecraft.bamboo": "Bambú",
  "block.minecraft.bamboo_block": "Bloque de bambú",
  "block.minecraft.bamboo_button": "Botón de bambú",
  "block.minecraft.bamboo_door": "Puerta de bambú",
  "block.minecraft.bamboo_fence": "Reja de bambú",
  "block.minecraft.bamboo_fence_gate": "Portón de bambú",
  "block.minecraft.bamboo_hanging_sign": "Cartel colgante de bambú",
  "block.minecraft.bamboo_mosaic": "Mosaico de bambú",
  "block.minecraft.bamboo_mosaic_slab": "Baldosa de mosaico de bambú",
  "block.minecraft.bamboo_mosaic_stairs": "Escaleras de mosaico de bambú",
  "block.minecraft.bamboo_planks": "Madera de bambú",
  "block.minecraft.bamboo_pressure_plate": "Placa de presión de bambú",
  "block.minecraft.bamboo_sapling": "Brote de bambú",
  "block.minecraft.bamboo_shelf": "Estante de bambú",
  "block.minecraft.bamboo_sign": "Cartel de bambú",
  "block.minecraft.bamboo_slab": "Baldosa de bambú",
  "block.minecraft.bamboo_stairs": "Escaleras de bambú",
  "block.minecraft.bamboo_trapdoor": "Escotilla de bambú",
  "block.minecraft.bamboo_wall_hanging_sign": "Cartel colgante de bambú en pared",
  "block.minecraft.bamboo_wall_sign": "Cartel de bambú en pared",
  "block.minecraft.banner.base.black": "Paño completamente negro",
  "block.minecraft.banner.base.blue": "Paño completamente azul",
  "block.minecraft.banner.base.brown": "Paño completamente marrón",
  "block.minecraft.banner.base.cyan": "Paño completamente cian",
  "block.minecraft.banner.base.gray": "Paño completamente gris",
  "block.minecraft.banner.base.green": "Paño completamente verde",
  "block.minecraft.banner.base.light_blue": "Paño completamente celeste",
  "block.minecraft.banner.base.light_gray": "Paño completamente gris claro",
  "block.minecraft.banner.base.lime": "Paño completamente verde lima",
  "block.minecraft.banner.base.magenta": "Paño completamente magenta",
  "block.minecraft.banner.base.orange": "Paño completamente naranja",
  "block.minecraft.banner.base.pink": "Paño completamente rosa",
  "block.minecraft.banner.base.purple": "Paño completamente violeta",
  "block.minecraft.banner.base.red": "Paño completamente rojo",
  "block.minecraft.banner.base.white": "Paño completamente blanco",
  "block.minecraft.banner.base.yellow": "Paño completamente amarillo",
  "block.minecraft.banner.border.black": "Bordura negra",
  "block.minecraft.banner.border.blue": "Bordura azul",
  "block.minecraft.banner.border.brown": "Bordura marrón",
  "block.minecraft.banner.border.cyan": "Bordura cian",
  "block.minecraft.banner.border.gray": "Bordura gris",
  "block.minecraft.banner.border.green": "Bordura verde",
  "block.minecraft.banner.border.light_blue": "Bordura celeste",
  "block.minecraft.banner.border.light_gray": "Bordura gris claro",
  "block.minecraft.banner.border.lime": "Bordura verde lima",
  "block.minecraft.banner.border.magenta": "Bordura magenta",
  "block.minecraft.banner.border.orange": "Bordura naranja",
  "block.minecraft.banner.border.pink": "Bordura rosa",
  "block.minecraft.banner.border.purple": "Bordura violeta",
  "block.minecraft.banner.border.red": "Bordura roja",
  "block.minecraft.banner.border.white": "Bordura blanca",
  "block.minecraft.banner.border.yellow": "Bordura amarilla",
  "block.minecraft.banner.bricks.black": "Mazonado negro",
  "block.minecraft.banner.bricks.blue": "Mazonado azul",
  "block.minecraft.banner.bricks.brown": "Mazonado marrón",
  "block.minecraft.banner.bricks.cyan": "Mazonado cian",
  "block.minecraft.banner.bricks.gray": "Mazonado gris",
  "block.minecraft.banner.bricks.green": "Mazonado verde",
  "block.minecraft.banner.bricks.light_blue": "Mazonado celeste",
  "block.minecraft.banner.bricks.light_gray": "Mazonado gris claro",
  "block.minecraft.banner.bricks.lime": "Mazonado verde lima",
  "block.minecraft.banner.bricks.magenta": "Mazonado magenta",
  "block.minecraft.banner.bricks.orange": "Mazonado naranja",
  "block.minecraft.banner.bricks.pink": "Mazonado rosa",
  "block.minecraft.banner.bricks.purple": "Mazonado violeta",
  "block.minecraft.banner.bricks.red": "Mazonado rojo",
  "block.minecraft.banner.bricks.white": "Mazonado blanco",
  "block.minecraft.banner.bricks.yellow": "Mazonado amarillo",
  "block.minecraft.banner.circle.black": "Roel negro",
  "block.minecraft.banner.circle.blue": "Roel azul",
  "block.minecraft.banner.circle.brown": "Roel marrón",
  "block.minecraft.banner.circle.cyan": "Roel cian",
  "block.minecraft.banner.circle.gray": "Roel gris",
  "block.minecraft.banner.circle.green": "Roel verde",
  "block.minecraft.banner.circle.light_blue": "Roel celeste",
  "block.minecraft.banner.circle.light_gray": "Roel gris claro",
  "block.minecraft.banner.circle.lime": "Roel verde lima",
  "block.minecraft.banner.circle.magenta": "Roel magenta",
  "block.minecraft.banner.circle.orange": "Roel naranja",
  "block.minecraft.banner.circle.pink": "Roel rosa",
  "block.minecraft.banner.circle.purple": "Roel violeta",
  "block.minecraft.banner.circle.red": "Roel rojo",
  "block.minecraft.banner.circle.white": "Roel blanco",
  "block.minecraft.banner.circle.yellow": "Roel amarillo",
  "block.minecraft.banner.creeper.black": "Estampado negro de creeper",
  "block.minecraft.banner.creeper.blue": "Estampado azul de creeper",
  "block.minecraft.banner.creeper.brown": "Estampado marrón de creeper",
  "block.minecraft.banner.creeper.cyan": "Estampado cian de creeper",
  "block.minecraft.banner.creeper.gray": "Estampado gris de creeper",
  "block.minecraft.banner.creeper.green": "Estampado verde de creeper",
  "block.minecraft.banner.creeper.light_blue": "Estampado celeste de creeper",
  "block.minecraft.banner.creeper.light_gray": "Estampado gris claro de creeper",
  "block.minecraft.banner.creeper.lime": "Estampado verde lima de creeper",
  "block.minecraft.banner.creeper.magenta": "Estampado magenta de creeper",
  "block.minecraft.banner.creeper.orange": "Estampado naranja de creeper",
  "block.minecraft.banner.creeper.pink": "Estampado rosa de creeper",
  "block.minecraft.banner.creeper.purple": "Estampado violeta de creeper",
  "block.minecraft.banner.creeper.red": "Estampado rojo de creeper",
  "block.minecraft.banner.creeper.white": "Estampado blanco de creeper",
  "block.minecraft.banner.creeper.yellow": "Estampado amariillo de creeper",
  "block.minecraft.banner.cross.black": "Aspa negra",
  "block.minecraft.banner.cross.blue": "Aspa azul",
  "block.minecraft.banner.cross.brown": "Aspa marrón",
  "block.minecraft.banner.cross.cyan": "Aspa cian",
  "block.minecraft.banner.cross.gray": "Aspa gris",
  "block.minecraft.banner.cross.green": "Aspa verde",
  "block.minecraft.banner.cross.light_blue": "Aspa celeste",
  "block.minecraft.banner.cross.light_gray": "Aspa gris claro",
  "block.minecraft.banner.cross.lime": "Aspa verde lima",
  "block.minecraft.banner.cross.magenta": "Aspa magenta",
  "block.minecraft.banner.cross.orange": "Aspa naranja",
  "block.minecraft.banner.cross.pink": "Aspa rosa",
  "block.minecraft.banner.cross.purple": "Aspa violeta",
  "block.minecraft.banner.cross.red": "Aspa roja",
  "block.minecraft.banner.cross.white": "Aspa blanca",
  "block.minecraft.banner.cross.yellow": "Aspa amarilla",
  "block.minecraft.banner.curly_border.black": "Bordura negra dentada",
  "block.minecraft.banner.curly_border.blue": "Bordura azul dentada",
  "block.minecraft.banner.curly_border.brown": "Bordura marrón dentada",
  "block.minecraft.banner.curly_border.cyan": "Bordura cian dentada",
  "block.minecraft.banner.curly_border.gray": "Bordura gris dentada",
  "block.minecraft.banner.curly_border.green": "Bordura verde dentada",
  "block.minecraft.banner.curly_border.light_blue": "Bordura celeste dentada",
  "block.minecraft.banner.curly_border.light_gray": "Bordura gris claro dentada",
  "block.minecraft.banner.curly_border.lime": "Bordura verde lima dentada",
  "block.minecraft.banner.curly_border.magenta": "Bordura magenta dentada",
  "block.minecraft.banner.curly_border.orange": "Bordura naranja dentada",
  "block.minecraft.banner.curly_border.pink": "Bordura rosa dentada",
  "block.minecraft.banner.curly_border.purple": "Bordura violeta dentada",
  "block.minecraft.banner.curly_border.red": "Bordura roja dentada",
  "block.minecraft.banner.curly_border.white": "Bordura blanca dentada",
  "block.minecraft.banner.curly_border.yellow": "Bordura amarilla dentada",
  "block.minecraft.banner.diagonal_left.black": "Tajado negro",
  "block.minecraft.banner.diagonal_left.blue": "Tajado azul",
  "block.minecraft.banner.diagonal_left.brown": "Tajado marrón",
  "block.minecraft.banner.diagonal_left.cyan": "Tajado cian",
  "block.minecraft.banner.diagonal_left.gray": "Tajado gris",
  "block.minecraft.banner.diagonal_left.green": "Tajado verde",
  "block.minecraft.banner.diagonal_left.light_blue": "Tajado celeste",
  "block.minecraft.banner.diagonal_left.light_gray": "Tajado gris claro",
  "block.minecraft.banner.diagonal_left.lime": "Tajado verde lima",
  "block.minecraft.banner.diagonal_left.magenta": "Tajado magenta",
  "block.minecraft.banner.diagonal_left.orange": "Tajado naranja",
  "block.minecraft.banner.diagonal_left.pink": "Tajado rosa",
  "block.minecraft.banner.diagonal_left.purple": "Tajado violeta",
  "block.minecraft.banner.diagonal_left.red": "Tajado rojo",
  "block.minecraft.banner.diagonal_left.white": "Tajado blanco",
  "block.minecraft.banner.diagonal_left.yellow": "Tajado amarillo",
  "block.minecraft.banner.diagonal_right.black": "Tronchado negro",
  "block.minecraft.banner.diagonal_right.blue": "Tronchado azul",
  "block.minecraft.banner.diagonal_right.brown": "Tronchado marrón",
  "block.minecraft.banner.diagonal_right.cyan": "Tronchado cian",
  "block.minecraft.banner.diagonal_right.gray": "Tronchado gris",
  "block.minecraft.banner.diagonal_right.green": "Tronchado verde",
  "block.minecraft.banner.diagonal_right.light_blue": "Tronchado celeste",
  "block.minecraft.banner.diagonal_right.light_gray": "Tronchado gris claro",
  "block.minecraft.banner.diagonal_right.lime": "Tronchado verde lima",
  "block.minecraft.banner.diagonal_right.magenta": "Tronchado magenta",
  "block.minecraft.banner.diagonal_right.orange": "Tronchado naranja",
  "block.minecraft.banner.diagonal_right.pink": "Tronchado rosa",
  "block.minecraft.banner.diagonal_right.purple": "Tronchado violeta",
  "block.minecraft.banner.diagonal_right.red": "Tronchado rojo",
  "block.minecraft.banner.diagonal_right.white": "Tronchado blanco",
  "block.minecraft.banner.diagonal_right.yellow": "Tronchado amarillo",
  "block.minecraft.banner.diagonal_up_left.black": "Tronchado negro invertido",
  "block.minecraft.banner.diagonal_up_left.blue": "Tronchado azul invertido",
  "block.minecraft.banner.diagonal_up_left.brown": "Tronchado marrón invertido",
  "block.minecraft.banner.diagonal_up_left.cyan": "Tronchado cian invertido",
  "block.minecraft.banner.diagonal_up_left.gray": "Tronchado gris invertido",
  "block.minecraft.banner.diagonal_up_left.green": "Tronchado verde invertido",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Tronchado celeste invertido",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Tronchado gris claro invertido",
  "block.minecraft.banner.diagonal_up_left.lime": "Tronchado verde lima invertido",
  "block.minecraft.banner.diagonal_up_left.magenta": "Tronchado magenta invertido",
  "block.minecraft.banner.diagonal_up_left.orange": "Tronchado naranja invertido",
  "block.minecraft.banner.diagonal_up_left.pink": "Tronchado rosa invertido",
  "block.minecraft.banner.diagonal_up_left.purple": "Tronchado violeta invertido",
  "block.minecraft.banner.diagonal_up_left.red": "Tronchado rojo invertido",
  "block.minecraft.banner.diagonal_up_left.white": "Tronchado blanco invertido",
  "block.minecraft.banner.diagonal_up_left.yellow": "Tronchado amarillo invertido",
  "block.minecraft.banner.diagonal_up_right.black": "Tajado negro invertido",
  "block.minecraft.banner.diagonal_up_right.blue": "Tajado azul invertido",
  "block.minecraft.banner.diagonal_up_right.brown": "Tajado marrón invertido",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tajado cian invertido",
  "block.minecraft.banner.diagonal_up_right.gray": "Tajado gris invertido",
  "block.minecraft.banner.diagonal_up_right.green": "Tajado verde invertido",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Tajado celeste invertido",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Tajado gris claro invertido",
  "block.minecraft.banner.diagonal_up_right.lime": "Tajado verde lima invertido",
  "block.minecraft.banner.diagonal_up_right.magenta": "Tajado magenta invertido",
  "block.minecraft.banner.diagonal_up_right.orange": "Tajado naranja invertido",
  "block.minecraft.banner.diagonal_up_right.pink": "Tajado rosa invertido",
  "block.minecraft.banner.diagonal_up_right.purple": "Tajado violeta invertido",
  "block.minecraft.banner.diagonal_up_right.red": "Tajado rojo invertido",
  "block.minecraft.banner.diagonal_up_right.white": "Tajado blanco invertido",
  "block.minecraft.banner.diagonal_up_right.yellow": "Tajado amarillo invertido",
  "block.minecraft.banner.flow.black": "Estampado negro de espiral",
  "block.minecraft.banner.flow.blue": "Estampado azul de espiral",
  "block.minecraft.banner.flow.brown": "Estampado marrón de espiral",
  "block.minecraft.banner.flow.cyan": "Estampado cian de espiral",
  "block.minecraft.banner.flow.gray": "Estampado gris de espiral",
  "block.minecraft.banner.flow.green": "Estampado verde de espiral",
  "block.minecraft.banner.flow.light_blue": "Estampado celeste de espiral",
  "block.minecraft.banner.flow.light_gray": "Estampado gris claro de espiral",
  "block.minecraft.banner.flow.lime": "Estampado verde lima de espiral",
  "block.minecraft.banner.flow.magenta": "Estampado magenta de espiral",
  "block.minecraft.banner.flow.orange": "Estampado naranja de espiral",
  "block.minecraft.banner.flow.pink": "Estampado rosa de espiral",
  "block.minecraft.banner.flow.purple": "Estampado violeta de espiral",
  "block.minecraft.banner.flow.red": "Estampado rojo de espiral",
  "block.minecraft.banner.flow.white": "Estampado blanco de espiral",
  "block.minecraft.banner.flow.yellow": "Estampado amarillo de espiral",
  "block.minecraft.banner.flower.black": "Estampado negro de flor",
  "block.minecraft.banner.flower.blue": "Estampado azul de flor",
  "block.minecraft.banner.flower.brown": "Estampado marrón de flor",
  "block.minecraft.banner.flower.cyan": "Estampado cian de flor",
  "block.minecraft.banner.flower.gray": "Estampado gris de flor",
  "block.minecraft.banner.flower.green": "Estampado verde de flor",
  "block.minecraft.banner.flower.light_blue": "Estampado celeste de flor",
  "block.minecraft.banner.flower.light_gray": "Estampado gris claro de flor",
  "block.minecraft.banner.flower.lime": "Estampado verde lima de flor",
  "block.minecraft.banner.flower.magenta": "Estampado magenta de flor",
  "block.minecraft.banner.flower.orange": "Estampado naranja de flor",
  "block.minecraft.banner.flower.pink": "Estampado rosa de flor",
  "block.minecraft.banner.flower.purple": "Estampado violeta de flor",
  "block.minecraft.banner.flower.red": "Estampado rojo de flor",
  "block.minecraft.banner.flower.white": "Estampado blanco de flor",
  "block.minecraft.banner.flower.yellow": "Estampado amarillo de flor",
  "block.minecraft.banner.globe.black": "Planeta negro",
  "block.minecraft.banner.globe.blue": "Planeta azul",
  "block.minecraft.banner.globe.brown": "Planeta marrón",
  "block.minecraft.banner.globe.cyan": "Planeta cian",
  "block.minecraft.banner.globe.gray": "Planeta gris",
  "block.minecraft.banner.globe.green": "Planeta verde",
  "block.minecraft.banner.globe.light_blue": "Planeta celeste",
  "block.minecraft.banner.globe.light_gray": "Planeta gris claro",
  "block.minecraft.banner.globe.lime": "Planeta verde lima",
  "block.minecraft.banner.globe.magenta": "Planeta magenta",
  "block.minecraft.banner.globe.orange": "Planeta naranja",
  "block.minecraft.banner.globe.pink": "Planeta rosa",
  "block.minecraft.banner.globe.purple": "Planeta violeta",
  "block.minecraft.banner.globe.red": "Planeta rojo",
  "block.minecraft.banner.globe.white": "Planeta blanco",
  "block.minecraft.banner.globe.yellow": "Planeta amarillo",
  "block.minecraft.banner.gradient.black": "Gradiente negro",
  "block.minecraft.banner.gradient.blue": "Gradiente azul",
  "block.minecraft.banner.gradient.brown": "Gradiente marrón",
  "block.minecraft.banner.gradient.cyan": "Gradiente cian",
  "block.minecraft.banner.gradient.gray": "Gradiente gris",
  "block.minecraft.banner.gradient.green": "Gradiente verde",
  "block.minecraft.banner.gradient.light_blue": "Gradiente celeste",
  "block.minecraft.banner.gradient.light_gray": "Gradiente gris claro",
  "block.minecraft.banner.gradient.lime": "Gradiente verde lima",
  "block.minecraft.banner.gradient.magenta": "Gradiente magenta",
  "block.minecraft.banner.gradient.orange": "Gradiente naranja",
  "block.minecraft.banner.gradient.pink": "Gradiente rosa",
  "block.minecraft.banner.gradient.purple": "Gradiente violeta",
  "block.minecraft.banner.gradient.red": "Gradiente rojo",
  "block.minecraft.banner.gradient.white": "Gradiente blanco",
  "block.minecraft.banner.gradient.yellow": "Gradiente amarillo",
  "block.minecraft.banner.gradient_up.black": "Gradiente negro en base",
  "block.minecraft.banner.gradient_up.blue": "Gradiente azul en base",
  "block.minecraft.banner.gradient_up.brown": "Gradiente marrón en base",
  "block.minecraft.banner.gradient_up.cyan": "Gradiente cian en base",
  "block.minecraft.banner.gradient_up.gray": "Gradiente gris en base",
  "block.minecraft.banner.gradient_up.green": "Gradiente verde en base",
  "block.minecraft.banner.gradient_up.light_blue": "Gradiente celeste en base",
  "block.minecraft.banner.gradient_up.light_gray": "Gradiente gris claro en base",
  "block.minecraft.banner.gradient_up.lime": "Gradiente verde lima en base",
  "block.minecraft.banner.gradient_up.magenta": "Gradiente magenta en base",
  "block.minecraft.banner.gradient_up.orange": "Gradiente naranja en base",
  "block.minecraft.banner.gradient_up.pink": "Gradiente rosa en base",
  "block.minecraft.banner.gradient_up.purple": "Gradiente violeta en base",
  "block.minecraft.banner.gradient_up.red": "Gradiente rojo en base",
  "block.minecraft.banner.gradient_up.white": "Gradiente blanco en base",
  "block.minecraft.banner.gradient_up.yellow": "Gradiente amarillo en base",
  "block.minecraft.banner.guster.black": "Estampado negro de breeze",
  "block.minecraft.banner.guster.blue": "Estampado azul de breeze",
  "block.minecraft.banner.guster.brown": "Estampado marrón de breeze",
  "block.minecraft.banner.guster.cyan": "Estampado cian de breeze",
  "block.minecraft.banner.guster.gray": "Estampado gris de breeze",
  "block.minecraft.banner.guster.green": "Estampado verde de breeze",
  "block.minecraft.banner.guster.light_blue": "Estampado celeste de breeze",
  "block.minecraft.banner.guster.light_gray": "Estampado gris claro de breeze",
  "block.minecraft.banner.guster.lime": "Estampado verde lima de breeze",
  "block.minecraft.banner.guster.magenta": "Estampado magenta de breeze",
  "block.minecraft.banner.guster.orange": "Estampado naranja de breeze",
  "block.minecraft.banner.guster.pink": "Estampado rosa de breeze",
  "block.minecraft.banner.guster.purple": "Estampado violeta de breeze",
  "block.minecraft.banner.guster.red": "Estampado rojo de breeze",
  "block.minecraft.banner.guster.white": "Estampado blanco de breeze",
  "block.minecraft.banner.guster.yellow": "Estampado amarillo de breeze",
  "block.minecraft.banner.half_horizontal.black": "Cortado negro",
  "block.minecraft.banner.half_horizontal.blue": "Cortado azul",
  "block.minecraft.banner.half_horizontal.brown": "Cortado marrón",
  "block.minecraft.banner.half_horizontal.cyan": "Cortado cian",
  "block.minecraft.banner.half_horizontal.gray": "Cortado gris",
  "block.minecraft.banner.half_horizontal.green": "Cortado verde",
  "block.minecraft.banner.half_horizontal.light_blue": "Cortado celeste",
  "block.minecraft.banner.half_horizontal.light_gray": "Cortado gris claro",
  "block.minecraft.banner.half_horizontal.lime": "Cortado verde lima",
  "block.minecraft.banner.half_horizontal.magenta": "Cortado magenta",
  "block.minecraft.banner.half_horizontal.orange": "Cortado naranja",
  "block.minecraft.banner.half_horizontal.pink": "Cortado rosa",
  "block.minecraft.banner.half_horizontal.purple": "Cortado violeta",
  "block.minecraft.banner.half_horizontal.red": "Cortado rojo",
  "block.minecraft.banner.half_horizontal.white": "Cortado blanco",
  "block.minecraft.banner.half_horizontal.yellow": "Cortado amarillo",
  "block.minecraft.banner.half_horizontal_bottom.black": "Cortado negro invertido",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Cortado azul invertido",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Cortado marrón invertido",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cortado cian invertido",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Cortado gris invertido",
  "block.minecraft.banner.half_horizontal_bottom.green": "Cortado verde invertido",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Cortado celeste invertido",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Cortado gris claro invertido",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Cortado verde lima invertido",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Cortado magenta invertido",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Cortado naranja invertido",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Cortado rosa invertido",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Cortado violeta invertido",
  "block.minecraft.banner.half_horizontal_bottom.red": "Cortado rojo invertido",
  "block.minecraft.banner.half_horizontal_bottom.white": "Cortado blanco invertido",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Cortado amarillo invertido",
  "block.minecraft.banner.half_vertical.black": "Flanco negro a diestra",
  "block.minecraft.banner.half_vertical.blue": "Flanco azul a diestra",
  "block.minecraft.banner.half_vertical.brown": "Flanco marrón a diestra",
  "block.minecraft.banner.half_vertical.cyan": "Flanco cian a diestra",
  "block.minecraft.banner.half_vertical.gray": "Flanco gris a diestra",
  "block.minecraft.banner.half_vertical.green": "Flanco verde a diestra",
  "block.minecraft.banner.half_vertical.light_blue": "Flanco celeste a diestra",
  "block.minecraft.banner.half_vertical.light_gray": "Flanco gris claro a diestra",
  "block.minecraft.banner.half_vertical.lime": "Flanco verde lima a diestra",
  "block.minecraft.banner.half_vertical.magenta": "Flanco magenta a diestra",
  "block.minecraft.banner.half_vertical.orange": "Flanco naranja a diestra",
  "block.minecraft.banner.half_vertical.pink": "Flanco rosa a diestra",
  "block.minecraft.banner.half_vertical.purple": "Flanco violeta a diestra",
  "block.minecraft.banner.half_vertical.red": "Flanco rojo a diestra",
  "block.minecraft.banner.half_vertical.white": "Flanco blanco a diestra",
  "block.minecraft.banner.half_vertical.yellow": "Flanco amarillo a diestra",
  "block.minecraft.banner.half_vertical_right.black": "Flanco negro a siniestra",
  "block.minecraft.banner.half_vertical_right.blue": "Flanco azul a siniestra",
  "block.minecraft.banner.half_vertical_right.brown": "Flanco marrón a siniestra",
  "block.minecraft.banner.half_vertical_right.cyan": "Flanco cian a siniestra",
  "block.minecraft.banner.half_vertical_right.gray": "Flanco gris a siniestra",
  "block.minecraft.banner.half_vertical_right.green": "Flanco verde a siniestra",
  "block.minecraft.banner.half_vertical_right.light_blue": "Flanco celeste a siniestra",
  "block.minecraft.banner.half_vertical_right.light_gray": "Flanco gris claro a siniestra",
  "block.minecraft.banner.half_vertical_right.lime": "Flanco verde lima a siniestra",
  "block.minecraft.banner.half_vertical_right.magenta": "Flanco magenta a siniestra",
  "block.minecraft.banner.half_vertical_right.orange": "Flanco naranja a siniestra",
  "block.minecraft.banner.half_vertical_right.pink": "Flanco rosa a siniestra",
  "block.minecraft.banner.half_vertical_right.purple": "Flanco violeta a siniestra",
  "block.minecraft.banner.half_vertical_right.red": "Flanco rojo a siniestra",
  "block.minecraft.banner.half_vertical_right.white": "Flanco blanco a siniestra",
  "block.minecraft.banner.half_vertical_right.yellow": "Flanco amarillo a siniestra",
  "block.minecraft.banner.mojang.black": "Cosa negra",
  "block.minecraft.banner.mojang.blue": "Cosa azul",
  "block.minecraft.banner.mojang.brown": "Cosa marrón",
  "block.minecraft.banner.mojang.cyan": "Cosa cian",
  "block.minecraft.banner.mojang.gray": "Cosa gris",
  "block.minecraft.banner.mojang.green": "Cosa verde",
  "block.minecraft.banner.mojang.light_blue": "Cosa celeste",
  "block.minecraft.banner.mojang.light_gray": "Cosa gris claro",
  "block.minecraft.banner.mojang.lime": "Cosa verde lima",
  "block.minecraft.banner.mojang.magenta": "Cosa magenta",
  "block.minecraft.banner.mojang.orange": "Cosa naranja",
  "block.minecraft.banner.mojang.pink": "Cosa rosa",
  "block.minecraft.banner.mojang.purple": "Cosa violeta",
  "block.minecraft.banner.mojang.red": "Cosa roja",
  "block.minecraft.banner.mojang.white": "Cosa blanca",
  "block.minecraft.banner.mojang.yellow": "Cosa amarilla",
  "block.minecraft.banner.piglin.black": "Hocico negro",
  "block.minecraft.banner.piglin.blue": "Hocico azul",
  "block.minecraft.banner.piglin.brown": "Hocico marrón",
  "block.minecraft.banner.piglin.cyan": "Hocico cian",
  "block.minecraft.banner.piglin.gray": "Hocico gris",
  "block.minecraft.banner.piglin.green": "Hocico verde",
  "block.minecraft.banner.piglin.light_blue": "Hocico celeste",
  "block.minecraft.banner.piglin.light_gray": "Hocico gris claro",
  "block.minecraft.banner.piglin.lime": "Hocico verde lima",
  "block.minecraft.banner.piglin.magenta": "Hocico magenta",
  "block.minecraft.banner.piglin.orange": "Hocico naranja",
  "block.minecraft.banner.piglin.pink": "Hocico rosa",
  "block.minecraft.banner.piglin.purple": "Hocico violeta",
  "block.minecraft.banner.piglin.red": "Hocico rojo",
  "block.minecraft.banner.piglin.white": "Hocico blanco",
  "block.minecraft.banner.piglin.yellow": "Hocico amarillo",
  "block.minecraft.banner.rhombus.black": "Rombo negro",
  "block.minecraft.banner.rhombus.blue": "Rombo azul",
  "block.minecraft.banner.rhombus.brown": "Rombo marrón",
  "block.minecraft.banner.rhombus.cyan": "Rombo cian",
  "block.minecraft.banner.rhombus.gray": "Rombo gris",
  "block.minecraft.banner.rhombus.green": "Rombo verde",
  "block.minecraft.banner.rhombus.light_blue": "Rombo celeste",
  "block.minecraft.banner.rhombus.light_gray": "Rombo gris claro",
  "block.minecraft.banner.rhombus.lime": "Rombo verde lima",
  "block.minecraft.banner.rhombus.magenta": "Rombo magenta",
  "block.minecraft.banner.rhombus.orange": "Rombo naranja",
  "block.minecraft.banner.rhombus.pink": "Rombo rosa",
  "block.minecraft.banner.rhombus.purple": "Rombo violeta",
  "block.minecraft.banner.rhombus.red": "Rombo rojo",
  "block.minecraft.banner.rhombus.white": "Rombo blanco",
  "block.minecraft.banner.rhombus.yellow": "Rombo amarillo",
  "block.minecraft.banner.skull.black": "Estampado negro de cráneo",
  "block.minecraft.banner.skull.blue": "Estampado azul de cráneo",
  "block.minecraft.banner.skull.brown": "Estampado marrón de cráneo",
  "block.minecraft.banner.skull.cyan": "Estampado cian de cráneo",
  "block.minecraft.banner.skull.gray": "Estampado gris de cráneo",
  "block.minecraft.banner.skull.green": "Estampado verde de cráneo",
  "block.minecraft.banner.skull.light_blue": "Estampado celeste de cráneo",
  "block.minecraft.banner.skull.light_gray": "Estampado gris claro de cráneo",
  "block.minecraft.banner.skull.lime": "Estampado verde lima de cráneo",
  "block.minecraft.banner.skull.magenta": "Estampado magenta de cráneo",
  "block.minecraft.banner.skull.orange": "Estampado naranja de cráneo",
  "block.minecraft.banner.skull.pink": "Estampado rosa de cráneo",
  "block.minecraft.banner.skull.purple": "Estampado violeta de cráneo",
  "block.minecraft.banner.skull.red": "Estampado rojo de cráneo",
  "block.minecraft.banner.skull.white": "Estampado blanco de cráneo",
  "block.minecraft.banner.skull.yellow": "Estampado amarillo de cráneo",
  "block.minecraft.banner.small_stripes.black": "Bastonado negro",
  "block.minecraft.banner.small_stripes.blue": "Bastonado azul",
  "block.minecraft.banner.small_stripes.brown": "Bastonado marrón",
  "block.minecraft.banner.small_stripes.cyan": "Bastonado cian",
  "block.minecraft.banner.small_stripes.gray": "Bastonado gris",
  "block.minecraft.banner.small_stripes.green": "Bastonado verde",
  "block.minecraft.banner.small_stripes.light_blue": "Bastonado celeste",
  "block.minecraft.banner.small_stripes.light_gray": "Bastonado gris claro",
  "block.minecraft.banner.small_stripes.lime": "Bastonado verde lima",
  "block.minecraft.banner.small_stripes.magenta": "Bastonado magenta",
  "block.minecraft.banner.small_stripes.orange": "Bastonado naranja",
  "block.minecraft.banner.small_stripes.pink": "Bastonado rosa",
  "block.minecraft.banner.small_stripes.purple": "Bastonado violeta",
  "block.minecraft.banner.small_stripes.red": "Bastonado rojo",
  "block.minecraft.banner.small_stripes.white": "Bastonado blanco",
  "block.minecraft.banner.small_stripes.yellow": "Bastonado amarillo",
  "block.minecraft.banner.square_bottom_left.black": "Cantón negro en base a diestra",
  "block.minecraft.banner.square_bottom_left.blue": "Cantón azul en base a diestra",
  "block.minecraft.banner.square_bottom_left.brown": "Cantón marrón en base a diestra",
  "block.minecraft.banner.square_bottom_left.cyan": "Cantón cian en base a diestra",
  "block.minecraft.banner.square_bottom_left.gray": "Cantón gris en base a diestra",
  "block.minecraft.banner.square_bottom_left.green": "Cantón verde en base a diestra",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cantón celeste en base a diestra",
  "block.minecraft.banner.square_bottom_left.light_gray": "Cantón gris claro en base a diestra",
  "block.minecraft.banner.square_bottom_left.lime": "Cantón verde lima en base a diestra",
  "block.minecraft.banner.square_bottom_left.magenta": "Cantón magenta en base a diestra",
  "block.minecraft.banner.square_bottom_left.orange": "Cantón naranja en base a diestra",
  "block.minecraft.banner.square_bottom_left.pink": "Cantón rosa en base a diestra",
  "block.minecraft.banner.square_bottom_left.purple": "Cantón violeta en base a diestra",
  "block.minecraft.banner.square_bottom_left.red": "Cantón rojo en base a diestra",
  "block.minecraft.banner.square_bottom_left.white": "Cantón blanco en base a diestra",
  "block.minecraft.banner.square_bottom_left.yellow": "Cantón amarillo en base a diestra",
  "block.minecraft.banner.square_bottom_right.black": "Cantón negro en base a siniestra",
  "block.minecraft.banner.square_bottom_right.blue": "Cantón azul en base a siniestra",
  "block.minecraft.banner.square_bottom_right.brown": "Cantón marrón en base a siniestra",
  "block.minecraft.banner.square_bottom_right.cyan": "Cantón cian en base a siniestra",
  "block.minecraft.banner.square_bottom_right.gray": "Cantón gris en base a siniestra",
  "block.minecraft.banner.square_bottom_right.green": "Cantón verde en base a siniestra",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cantón celeste en base a siniestra",
  "block.minecraft.banner.square_bottom_right.light_gray": "Cantón gris claro en base a siniestra",
  "block.minecraft.banner.square_bottom_right.lime": "Cantón verde lima en base a siniestra",
  "block.minecraft.banner.square_bottom_right.magenta": "Cantón magenta en base a siniestra",
  "block.minecraft.banner.square_bottom_right.orange": "Cantón naranja en base a siniestra",
  "block.minecraft.banner.square_bottom_right.pink": "Cantón rosa en base a siniestra",
  "block.minecraft.banner.square_bottom_right.purple": "Cantón violeta en base a siniestra",
  "block.minecraft.banner.square_bottom_right.red": "Cantón rojo en base a siniestra",
  "block.minecraft.banner.square_bottom_right.white": "Cantón blanco en base a siniestra",
  "block.minecraft.banner.square_bottom_right.yellow": "Cantón amarillo en base a siniestra",
  "block.minecraft.banner.square_top_left.black": "Cantón negro en jefe a diestra",
  "block.minecraft.banner.square_top_left.blue": "Cantón azul en jefe a diestra",
  "block.minecraft.banner.square_top_left.brown": "Cantón marrón en jefe a diestra",
  "block.minecraft.banner.square_top_left.cyan": "Cantón cian en jefe a diestra",
  "block.minecraft.banner.square_top_left.gray": "Cantón gris en jefe a diestra",
  "block.minecraft.banner.square_top_left.green": "Cantón verde en jefe a diestra",
  "block.minecraft.banner.square_top_left.light_blue": "Cantón celeste en jefe a diestra",
  "block.minecraft.banner.square_top_left.light_gray": "Cantón gris claro en jefe a diestra",
  "block.minecraft.banner.square_top_left.lime": "Cantón verde lima en jefe a diestra",
  "block.minecraft.banner.square_top_left.magenta": "Cantón magenta en jefe a diestra",
  "block.minecraft.banner.square_top_left.orange": "Cantón naranja en jefe a diestra",
  "block.minecraft.banner.square_top_left.pink": "Cantón rosa en jefe a diestra",
  "block.minecraft.banner.square_top_left.purple": "Cantón violeta en jefe a diestra",
  "block.minecraft.banner.square_top_left.red": "Cantón rojo en jefe a diestra",
  "block.minecraft.banner.square_top_left.white": "Cantón blanco en jefe a diestra",
  "block.minecraft.banner.square_top_left.yellow": "Cantón amarillo en jefe a diestra",
  "block.minecraft.banner.square_top_right.black": "Cantón negro en jefe a siniestra",
  "block.minecraft.banner.square_top_right.blue": "Cantón azul en jefe a siniestra",
  "block.minecraft.banner.square_top_right.brown": "Cantón marrón en jefe a siniestra",
  "block.minecraft.banner.square_top_right.cyan": "Cantón cian en jefe a siniestra",
  "block.minecraft.banner.square_top_right.gray": "Cantón gris en jefe a siniestra",
  "block.minecraft.banner.square_top_right.green": "Cantón verde en jefe a siniestra",
  "block.minecraft.banner.square_top_right.light_blue": "Cantón celeste en jefe a siniestra",
  "block.minecraft.banner.square_top_right.light_gray": "Cantón gris claro en jefe a siniestra",
  "block.minecraft.banner.square_top_right.lime": "Cantón verde lima en jefe a siniestra",
  "block.minecraft.banner.square_top_right.magenta": "Cantón magenta en jefe a siniestra",
  "block.minecraft.banner.square_top_right.orange": "Cantón naranja en jefe a siniestra",
  "block.minecraft.banner.square_top_right.pink": "Cantón rosa en jefe a siniestra",
  "block.minecraft.banner.square_top_right.purple": "Cantón violeta en jefe a siniestra",
  "block.minecraft.banner.square_top_right.red": "Cantón rojo en jefe a siniestra",
  "block.minecraft.banner.square_top_right.white": "Cantón blanco en jefe a siniestra",
  "block.minecraft.banner.square_top_right.yellow": "Cantón amarillo en jefe a siniestra",
  "block.minecraft.banner.straight_cross.black": "Cruz negra",
  "block.minecraft.banner.straight_cross.blue": "Cruz azul",
  "block.minecraft.banner.straight_cross.brown": "Cruz marrón",
  "block.minecraft.banner.straight_cross.cyan": "Cruz cian",
  "block.minecraft.banner.straight_cross.gray": "Cruz gris",
  "block.minecraft.banner.straight_cross.green": "Cruz verde",
  "block.minecraft.banner.straight_cross.light_blue": "Cruz celeste",
  "block.minecraft.banner.straight_cross.light_gray": "Cruz gris claro",
  "block.minecraft.banner.straight_cross.lime": "Cruz verde lima",
  "block.minecraft.banner.straight_cross.magenta": "Cruz magenta",
  "block.minecraft.banner.straight_cross.orange": "Cruz naranja",
  "block.minecraft.banner.straight_cross.pink": "Cruz rosa",
  "block.minecraft.banner.straight_cross.purple": "Cruz violeta",
  "block.minecraft.banner.straight_cross.red": "Cruz roja",
  "block.minecraft.banner.straight_cross.white": "Cruz blanca",
  "block.minecraft.banner.straight_cross.yellow": "Cruz amarilla",
  "block.minecraft.banner.stripe_bottom.black": "Campaña negra",
  "block.minecraft.banner.stripe_bottom.blue": "Campaña azul",
  "block.minecraft.banner.stripe_bottom.brown": "Campaña marrón",
  "block.minecraft.banner.stripe_bottom.cyan": "Campaña cian",
  "block.minecraft.banner.stripe_bottom.gray": "Campaña gris",
  "block.minecraft.banner.stripe_bottom.green": "Campaña verde",
  "block.minecraft.banner.stripe_bottom.light_blue": "Campaña celeste",
  "block.minecraft.banner.stripe_bottom.light_gray": "Campaña gris claro",
  "block.minecraft.banner.stripe_bottom.lime": "Campaña verde lima",
  "block.minecraft.banner.stripe_bottom.magenta": "Campaña magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Campaña naranja",
  "block.minecraft.banner.stripe_bottom.pink": "Campaña rosa",
  "block.minecraft.banner.stripe_bottom.purple": "Campaña violeta",
  "block.minecraft.banner.stripe_bottom.red": "Campaña roja",
  "block.minecraft.banner.stripe_bottom.white": "Campaña blanca",
  "block.minecraft.banner.stripe_bottom.yellow": "Campaña amarilla",
  "block.minecraft.banner.stripe_center.black": "Palo negro",
  "block.minecraft.banner.stripe_center.blue": "Palo azul",
  "block.minecraft.banner.stripe_center.brown": "Palo marrón",
  "block.minecraft.banner.stripe_center.cyan": "Palo cian",
  "block.minecraft.banner.stripe_center.gray": "Palo gris",
  "block.minecraft.banner.stripe_center.green": "Palo verde",
  "block.minecraft.banner.stripe_center.light_blue": "Palo celeste",
  "block.minecraft.banner.stripe_center.light_gray": "Palo gris claro",
  "block.minecraft.banner.stripe_center.lime": "Palo verde lima",
  "block.minecraft.banner.stripe_center.magenta": "Palo magenta",
  "block.minecraft.banner.stripe_center.orange": "Palo naranja",
  "block.minecraft.banner.stripe_center.pink": "Palo rosa",
  "block.minecraft.banner.stripe_center.purple": "Palo violeta",
  "block.minecraft.banner.stripe_center.red": "Palo rojo",
  "block.minecraft.banner.stripe_center.white": "Palo blanco",
  "block.minecraft.banner.stripe_center.yellow": "Palo amarillo",
  "block.minecraft.banner.stripe_downleft.black": "Banda negra a siniestra",
  "block.minecraft.banner.stripe_downleft.blue": "Banda azul a siniestra",
  "block.minecraft.banner.stripe_downleft.brown": "Banda marrón a siniestra",
  "block.minecraft.banner.stripe_downleft.cyan": "Banda cian a siniestra",
  "block.minecraft.banner.stripe_downleft.gray": "Banda gris a siniestra",
  "block.minecraft.banner.stripe_downleft.green": "Banda verde a siniestra",
  "block.minecraft.banner.stripe_downleft.light_blue": "Banda celeste a siniestra",
  "block.minecraft.banner.stripe_downleft.light_gray": "Banda gris claro a siniestra",
  "block.minecraft.banner.stripe_downleft.lime": "Banda verde lima a siniestra",
  "block.minecraft.banner.stripe_downleft.magenta": "Banda magenta a siniestra",
  "block.minecraft.banner.stripe_downleft.orange": "Banda naranja a siniestra",
  "block.minecraft.banner.stripe_downleft.pink": "Banda rosa a siniestra",
  "block.minecraft.banner.stripe_downleft.purple": "Banda violeta a siniestra",
  "block.minecraft.banner.stripe_downleft.red": "Banda roja a siniestra",
  "block.minecraft.banner.stripe_downleft.white": "Banda blanca a siniestra",
  "block.minecraft.banner.stripe_downleft.yellow": "Banda amarilla a siniestra",
  "block.minecraft.banner.stripe_downright.black": "Banda negra",
  "block.minecraft.banner.stripe_downright.blue": "Banda azul",
  "block.minecraft.banner.stripe_downright.brown": "Banda marrón",
  "block.minecraft.banner.stripe_downright.cyan": "Banda cian",
  "block.minecraft.banner.stripe_downright.gray": "Banda gris",
  "block.minecraft.banner.stripe_downright.green": "Banda verde",
  "block.minecraft.banner.stripe_downright.light_blue": "Banda celeste",
  "block.minecraft.banner.stripe_downright.light_gray": "Banda gris claro",
  "block.minecraft.banner.stripe_downright.lime": "Banda verde lima",
  "block.minecraft.banner.stripe_downright.magenta": "Banda magenta",
  "block.minecraft.banner.stripe_downright.orange": "Banda naranja",
  "block.minecraft.banner.stripe_downright.pink": "Banda rosa",
  "block.minecraft.banner.stripe_downright.purple": "Banda violeta",
  "block.minecraft.banner.stripe_downright.red": "Banda roja",
  "block.minecraft.banner.stripe_downright.white": "Banda blanca",
  "block.minecraft.banner.stripe_downright.yellow": "Banda amarilla",
  "block.minecraft.banner.stripe_left.black": "Palo negro a diestra",
  "block.minecraft.banner.stripe_left.blue": "Palo azul a diestra",
  "block.minecraft.banner.stripe_left.brown": "Palo marrón a diestra",
  "block.minecraft.banner.stripe_left.cyan": "Palo cian a diestra",
  "block.minecraft.banner.stripe_left.gray": "Palo gris a diestra",
  "block.minecraft.banner.stripe_left.green": "Palo verde a diestra",
  "block.minecraft.banner.stripe_left.light_blue": "Palo celeste a diestra",
  "block.minecraft.banner.stripe_left.light_gray": "Palo gris claro a diestra",
  "block.minecraft.banner.stripe_left.lime": "Palo verde lima a diestra",
  "block.minecraft.banner.stripe_left.magenta": "Palo magenta a diestra",
  "block.minecraft.banner.stripe_left.orange": "Palo naranja a diestra",
  "block.minecraft.banner.stripe_left.pink": "Palo rosa a diestra",
  "block.minecraft.banner.stripe_left.purple": "Palo violeta a diestra",
  "block.minecraft.banner.stripe_left.red": "Palo rojo a diestra",
  "block.minecraft.banner.stripe_left.white": "Palo blanco a diestra",
  "block.minecraft.banner.stripe_left.yellow": "Palo amarillo a diestra",
  "block.minecraft.banner.stripe_middle.black": "Franja negra",
  "block.minecraft.banner.stripe_middle.blue": "Franja azul",
  "block.minecraft.banner.stripe_middle.brown": "Franja marrón",
  "block.minecraft.banner.stripe_middle.cyan": "Franja cian",
  "block.minecraft.banner.stripe_middle.gray": "Franja gris",
  "block.minecraft.banner.stripe_middle.green": "Franja verde",
  "block.minecraft.banner.stripe_middle.light_blue": "Franja celeste",
  "block.minecraft.banner.stripe_middle.light_gray": "Franja gris claro",
  "block.minecraft.banner.stripe_middle.lime": "Franja verde lima",
  "block.minecraft.banner.stripe_middle.magenta": "Franja magenta",
  "block.minecraft.banner.stripe_middle.orange": "Franja naranja",
  "block.minecraft.banner.stripe_middle.pink": "Franja rosa",
  "block.minecraft.banner.stripe_middle.purple": "Franja violeta",
  "block.minecraft.banner.stripe_middle.red": "Franja roja",
  "block.minecraft.banner.stripe_middle.white": "Franja blanca",
  "block.minecraft.banner.stripe_middle.yellow": "Franja amarilla",
  "block.minecraft.banner.stripe_right.black": "Palo negro a siniestra",
  "block.minecraft.banner.stripe_right.blue": "Palo azul a siniestra",
  "block.minecraft.banner.stripe_right.brown": "Palo marrón a siniestra",
  "block.minecraft.banner.stripe_right.cyan": "Palo cian a siniestra",
  "block.minecraft.banner.stripe_right.gray": "Palo gris a siniestra",
  "block.minecraft.banner.stripe_right.green": "Palo verde a siniestra",
  "block.minecraft.banner.stripe_right.light_blue": "Palo celeste a siniestra",
  "block.minecraft.banner.stripe_right.light_gray": "Palo gris claro a siniestra",
  "block.minecraft.banner.stripe_right.lime": "Palo verde lima a siniestra",
  "block.minecraft.banner.stripe_right.magenta": "Palo magenta a siniestra",
  "block.minecraft.banner.stripe_right.orange": "Palo naranja a siniestra",
  "block.minecraft.banner.stripe_right.pink": "Palo rosa a siniestra",
  "block.minecraft.banner.stripe_right.purple": "Palo violeta a siniestra",
  "block.minecraft.banner.stripe_right.red": "Palo rojo a siniestra",
  "block.minecraft.banner.stripe_right.white": "Palo blanco a siniestra",
  "block.minecraft.banner.stripe_right.yellow": "Palo amarillo a siniestra",
  "block.minecraft.banner.stripe_top.black": "Cantón negro",
  "block.minecraft.banner.stripe_top.blue": "Cantón azul",
  "block.minecraft.banner.stripe_top.brown": "Cantón marrón",
  "block.minecraft.banner.stripe_top.cyan": "Cantón cian",
  "block.minecraft.banner.stripe_top.gray": "Cantón gris",
  "block.minecraft.banner.stripe_top.green": "Cantón verde",
  "block.minecraft.banner.stripe_top.light_blue": "Cantón celeste",
  "block.minecraft.banner.stripe_top.light_gray": "Cantón gris claro",
  "block.minecraft.banner.stripe_top.lime": "Cantón verde lima",
  "block.minecraft.banner.stripe_top.magenta": "Cantón magenta",
  "block.minecraft.banner.stripe_top.orange": "Cantón naranja",
  "block.minecraft.banner.stripe_top.pink": "Cantón rosa",
  "block.minecraft.banner.stripe_top.purple": "Cantón violeta",
  "block.minecraft.banner.stripe_top.red": "Cantón rojo",
  "block.minecraft.banner.stripe_top.white": "Cantón blanco",
  "block.minecraft.banner.stripe_top.yellow": "Cantón amarillo",
  "block.minecraft.banner.triangle_bottom.black": "Chevrón negro",
  "block.minecraft.banner.triangle_bottom.blue": "Chevrón azul",
  "block.minecraft.banner.triangle_bottom.brown": "Chevrón marrón",
  "block.minecraft.banner.triangle_bottom.cyan": "Chevrón cian",
  "block.minecraft.banner.triangle_bottom.gray": "Chevrón gris",
  "block.minecraft.banner.triangle_bottom.green": "Chevrón verde",
  "block.minecraft.banner.triangle_bottom.light_blue": "Chevrón celeste",
  "block.minecraft.banner.triangle_bottom.light_gray": "Chevrón gris claro",
  "block.minecraft.banner.triangle_bottom.lime": "Chevrón verde lima",
  "block.minecraft.banner.triangle_bottom.magenta": "Chevrón magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Chevrón naranja",
  "block.minecraft.banner.triangle_bottom.pink": "Chevrón rosa",
  "block.minecraft.banner.triangle_bottom.purple": "Chevrón violeta",
  "block.minecraft.banner.triangle_bottom.red": "Chevrón rojo",
  "block.minecraft.banner.triangle_bottom.white": "Chevrón blanco",
  "block.minecraft.banner.triangle_bottom.yellow": "Chevrón amarillo",
  "block.minecraft.banner.triangle_top.black": "Chevrón negro invertido",
  "block.minecraft.banner.triangle_top.blue": "Chevrón azul invertido",
  "block.minecraft.banner.triangle_top.brown": "Chevrón marrón invertido",
  "block.minecraft.banner.triangle_top.cyan": "Chevrón cian invertido",
  "block.minecraft.banner.triangle_top.gray": "Chevrón gris invertido",
  "block.minecraft.banner.triangle_top.green": "Chevrón verde invertido",
  "block.minecraft.banner.triangle_top.light_blue": "Chevrón celeste invertido",
  "block.minecraft.banner.triangle_top.light_gray": "Chevrón gris claro invertido",
  "block.minecraft.banner.triangle_top.lime": "Chevrón verde lima invertido",
  "block.minecraft.banner.triangle_top.magenta": "Chevrón magenta invertido",
  "block.minecraft.banner.triangle_top.orange": "Chevrón naranja invertido",
  "block.minecraft.banner.triangle_top.pink": "Chevrón rosa invertido",
  "block.minecraft.banner.triangle_top.purple": "Chevrón violeta invertido",
  "block.minecraft.banner.triangle_top.red": "Chevrón rojo invertido",
  "block.minecraft.banner.triangle_top.white": "Chevrón blanco invertido",
  "block.minecraft.banner.triangle_top.yellow": "Chevrón amarillo invertido",
  "block.minecraft.banner.triangles_bottom.black": "Base negra dentada",
  "block.minecraft.banner.triangles_bottom.blue": "Base azul dentada",
  "block.minecraft.banner.triangles_bottom.brown": "Base marrón dentada",
  "block.minecraft.banner.triangles_bottom.cyan": "Base cian dentada",
  "block.minecraft.banner.triangles_bottom.gray": "Base gris dentada",
  "block.minecraft.banner.triangles_bottom.green": "Base verde dentada",
  "block.minecraft.banner.triangles_bottom.light_blue": "Base celeste dentada",
  "block.minecraft.banner.triangles_bottom.light_gray": "Base gris claro dentada",
  "block.minecraft.banner.triangles_bottom.lime": "Base verde lima dentada",
  "block.minecraft.banner.triangles_bottom.magenta": "Base magenta dentada",
  "block.minecraft.banner.triangles_bottom.orange": "Base naranja dentada",
  "block.minecraft.banner.triangles_bottom.pink": "Base rosa dentada",
  "block.minecraft.banner.triangles_bottom.purple": "Base violeta dentada",
  "block.minecraft.banner.triangles_bottom.red": "Base roja dentada",
  "block.minecraft.banner.triangles_bottom.white": "Base blanca dentada",
  "block.minecraft.banner.triangles_bottom.yellow": "Base amarilla dentada",
  "block.minecraft.banner.triangles_top.black": "Jefe negro dentado",
  "block.minecraft.banner.triangles_top.blue": "Jefe azul dentado",
  "block.minecraft.banner.triangles_top.brown": "Jefe marrón dentado",
  "block.minecraft.banner.triangles_top.cyan": "Jefe cian dentado",
  "block.minecraft.banner.triangles_top.gray": "Jefe gris dentado",
  "block.minecraft.banner.triangles_top.green": "Jefe verde dentado",
  "block.minecraft.banner.triangles_top.light_blue": "Jefe celeste dentado",
  "block.minecraft.banner.triangles_top.light_gray": "Chevrón azul",
  "block.minecraft.banner.triangles_top.lime": "Jefe verde lima dentado",
  "block.minecraft.banner.triangles_top.magenta": "Jefe magenta dentado",
  "block.minecraft.banner.triangles_top.orange": "Jefe naranja dentado",
  "block.minecraft.banner.triangles_top.pink": "Jefe rosa dentado",
  "block.minecraft.banner.triangles_top.purple": "Jefe violeta dentado",
  "block.minecraft.banner.triangles_top.red": "Jefe rojo dentado",
  "block.minecraft.banner.triangles_top.white": "Jefe blanco dentado",
  "block.minecraft.banner.triangles_top.yellow": "Jefe amarillo dentado",
  "block.minecraft.barrel": "Barril",
  "block.minecraft.barrier": "Barrera",
  "block.minecraft.basalt": "Basalto",
  "block.minecraft.beacon": "Faro",
  "block.minecraft.beacon.primary": "Poder primario",
  "block.minecraft.beacon.secondary": "Poder secundario",
  "block.minecraft.bed.no_sleep": "Sólo podés dormir de noche o durante una tormenta",
  "block.minecraft.bed.not_safe": "Ahora no podés dormir: hay monstruos cerca",
  "block.minecraft.bed.obstructed": "Esta cama está obstruida",
  "block.minecraft.bed.occupied": "La cama está ocupada",
  "block.minecraft.bed.too_far_away": "Ahora no podés dormir: la cama está lejos",
  "block.minecraft.bedrock": "Piedra madre",
  "block.minecraft.bee_nest": "Colmena de abejas",
  "block.minecraft.beehive": "Apiario de abejas",
  "block.minecraft.beetroots": "Remolachas",
  "block.minecraft.bell": "Campana",
  "block.minecraft.big_dripleaf": "Plantaforma",
  "block.minecraft.big_dripleaf_stem": "Tallo de plantaforma grande",
  "block.minecraft.birch_button": "Botón de abedul",
  "block.minecraft.birch_door": "Puerta de abedul",
  "block.minecraft.birch_fence": "Reja de abedul",
  "block.minecraft.birch_fence_gate": "Portón de abedul",
  "block.minecraft.birch_hanging_sign": "Cartel colgante de abedul",
  "block.minecraft.birch_leaves": "Hojas de abedul",
  "block.minecraft.birch_log": "Tronco de abedul",
  "block.minecraft.birch_planks": "Madera de abedul",
  "block.minecraft.birch_pressure_plate": "Placa de presión de abedul",
  "block.minecraft.birch_sapling": "Brote de abedul",
  "block.minecraft.birch_shelf": "Estante de abedul",
  "block.minecraft.birch_sign": "Cartel de abedul",
  "block.minecraft.birch_slab": "Baldosa de abedul",
  "block.minecraft.birch_stairs": "Escaleras de abedul",
  "block.minecraft.birch_trapdoor": "Escotilla de abedul",
  "block.minecraft.birch_wall_hanging_sign": "Cartel colgante de abedul en pared",
  "block.minecraft.birch_wall_sign": "Cartel de abedul en pared",
  "block.minecraft.birch_wood": "Leño de abedul",
  "block.minecraft.black_banner": "Estandarte negro",
  "block.minecraft.black_bed": "Cama negra",
  "block.minecraft.black_candle": "Vela negra",
  "block.minecraft.black_candle_cake": "Torta con vela negra",
  "block.minecraft.black_carpet": "Alfombra negra",
  "block.minecraft.black_concrete": "Concreto negro",
  "block.minecraft.black_concrete_powder": "Cemento negro",
  "block.minecraft.black_glazed_terracotta": "Azulejo negro",
  "block.minecraft.black_shulker_box": "Caja de shulker negra",
  "block.minecraft.black_stained_glass": "Vidrio negro",
  "block.minecraft.black_stained_glass_pane": "Panel de vidrio negro",
  "block.minecraft.black_terracotta": "Terracota negra",
  "block.minecraft.black_wool": "Lana negra",
  "block.minecraft.blackstone": "Piedra negra",
  "block.minecraft.blackstone_slab": "Baldosa de piedra negra",
  "block.minecraft.blackstone_stairs": "Escaleras de piedra negra",
  "block.minecraft.blackstone_wall": "Pared de piedra negra",
  "block.minecraft.blast_furnace": "Alto horno",
  "block.minecraft.blue_banner": "Estandarte azul",
  "block.minecraft.blue_bed": "Cama azul",
  "block.minecraft.blue_candle": "Vela azul",
  "block.minecraft.blue_candle_cake": "Torta con vela azul",
  "block.minecraft.blue_carpet": "Alfombra azul",
  "block.minecraft.blue_concrete": "Concreto azul",
  "block.minecraft.blue_concrete_powder": "Cemento azul",
  "block.minecraft.blue_glazed_terracotta": "Azulejo azul",
  "block.minecraft.blue_ice": "Hielo azul",
  "block.minecraft.blue_orchid": "Orquídea azul",
  "block.minecraft.blue_shulker_box": "Caja de shulker azul",
  "block.minecraft.blue_stained_glass": "Vidrio azul",
  "block.minecraft.blue_stained_glass_pane": "Panel de vidrio azul",
  "block.minecraft.blue_terracotta": "Terracota azul",
  "block.minecraft.blue_wool": "Lana azul",
  "block.minecraft.bone_block": "Bloque de huesos",
  "block.minecraft.bookshelf": "Biblioteca",
  "block.minecraft.brain_coral": "Coral de cerebro",
  "block.minecraft.brain_coral_block": "Bloque de coral de cerebro",
  "block.minecraft.brain_coral_fan": "Gorgonia de cerebro",
  "block.minecraft.brain_coral_wall_fan": "Gorgonia de cerebro en pared",
  "block.minecraft.brewing_stand": "Destiladora",
  "block.minecraft.brick_slab": "Baldosa de ladrillos",
  "block.minecraft.brick_stairs": "Escalera de ladrillos",
  "block.minecraft.brick_wall": "Pared de ladrillos",
  "block.minecraft.bricks": "Ladrillos",
  "block.minecraft.brown_banner": "Estandarte marrón",
  "block.minecraft.brown_bed": "Cama marrón",
  "block.minecraft.brown_candle": "Vela marrón",
  "block.minecraft.brown_candle_cake": "Torta con vela marrón",
  "block.minecraft.brown_carpet": "Alfombra marrón",
  "block.minecraft.brown_concrete": "Concreto marrón",
  "block.minecraft.brown_concrete_powder": "Cemento marrón",
  "block.minecraft.brown_glazed_terracotta": "Azulejo marrón",
  "block.minecraft.brown_mushroom": "Hongo marrón",
  "block.minecraft.brown_mushroom_block": "Bloque de hongo marrón",
  "block.minecraft.brown_shulker_box": "Caja de shulker marrón",
  "block.minecraft.brown_stained_glass": "Vidrio marrón",
  "block.minecraft.brown_stained_glass_pane": "Panel de vidrio marrón",
  "block.minecraft.brown_terracotta": "Terracota marrón",
  "block.minecraft.brown_wool": "Lana marrón",
  "block.minecraft.bubble_column": "Columna de burbujas",
  "block.minecraft.bubble_coral": "Coral de burbuja",
  "block.minecraft.bubble_coral_block": "Bloque de coral de burbuja",
  "block.minecraft.bubble_coral_fan": "Gorgonia de burbuja",
  "block.minecraft.bubble_coral_wall_fan": "Gorgonia de burbuja en pared",
  "block.minecraft.budding_amethyst": "Brotador de amatista",
  "block.minecraft.bush": "Arbusto",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Flor de cactus",
  "block.minecraft.cake": "Torta",
  "block.minecraft.calcite": "Calcita",
  "block.minecraft.calibrated_sculk_sensor": "Sensor de sculk calibrado",
  "block.minecraft.campfire": "Fogata",
  "block.minecraft.candle": "Vela",
  "block.minecraft.candle_cake": "Torta con vela",
  "block.minecraft.carrots": "Zanahorias",
  "block.minecraft.cartography_table": "Mesa de cartografía",
  "block.minecraft.carved_pumpkin": "Zapallo tallado",
  "block.minecraft.cauldron": "Caldero",
  "block.minecraft.cave_air": "Aire de cueva",
  "block.minecraft.cave_vines": "Enredaderas de cueva",
  "block.minecraft.cave_vines_plant": "Planta de enredaderas de cueva",
  "block.minecraft.chain": "Cadena",
  "block.minecraft.chain_command_block": "Bloque de comandos en cadena",
  "block.minecraft.cherry_button": "Botón de cerezo",
  "block.minecraft.cherry_door": "Puerta de cerezo",
  "block.minecraft.cherry_fence": "Reja de cerezo",
  "block.minecraft.cherry_fence_gate": "Portón de cerezo",
  "block.minecraft.cherry_hanging_sign": "Cartel colgante de cerezo",
  "block.minecraft.cherry_leaves": "Hojas de cerezo",
  "block.minecraft.cherry_log": "Tronco de cerezo",
  "block.minecraft.cherry_planks": "Madera de cerezo",
  "block.minecraft.cherry_pressure_plate": "Placa de presión de cerezo",
  "block.minecraft.cherry_sapling": "Brote de cerezo",
  "block.minecraft.cherry_shelf": "Estante de cerezo",
  "block.minecraft.cherry_sign": "Cartel de cerezo",
  "block.minecraft.cherry_slab": "Baldosa de cerezo",
  "block.minecraft.cherry_stairs": "Escaleras de cerezo",
  "block.minecraft.cherry_trapdoor": "Escotilla de cerezo",
  "block.minecraft.cherry_wall_hanging_sign": "Cartel colgante de cerezo en pared",
  "block.minecraft.cherry_wall_sign": "Cartel colgante de cerezo",
  "block.minecraft.cherry_wood": "Leño de cerezo",
  "block.minecraft.chest": "Baúl",
  "block.minecraft.chipped_anvil": "Yunque dañado",
  "block.minecraft.chiseled_bookshelf": "Biblioteca tallada",
  "block.minecraft.chiseled_copper": "Cobre cincelado",
  "block.minecraft.chiseled_deepslate": "Pizarra profunda cincelada",
  "block.minecraft.chiseled_nether_bricks": "Ladrillos del Nether cincelados",
  "block.minecraft.chiseled_polished_blackstone": "Piedra negra pulida cincelada",
  "block.minecraft.chiseled_quartz_block": "Cuarzo cincelado",
  "block.minecraft.chiseled_red_sandstone": "Arenisca roja cincelada",
  "block.minecraft.chiseled_resin_bricks": "Ladrillos de resina cincelados",
  "block.minecraft.chiseled_sandstone": "Arenisca cincelada",
  "block.minecraft.chiseled_stone_bricks": "Ladrillos de piedra cincelados",
  "block.minecraft.chiseled_tuff": "Toba cincelada",
  "block.minecraft.chiseled_tuff_bricks": "Ladrillos de toba cincelados",
  "block.minecraft.chorus_flower": "Flor de chorus",
  "block.minecraft.chorus_plant": "Chorus",
  "block.minecraft.clay": "Arcilla",
  "block.minecraft.closed_eyeblossom": "Miraflor cerrada",
  "block.minecraft.coal_block": "Bloque de carbón",
  "block.minecraft.coal_ore": "Mineral de carbón",
  "block.minecraft.coarse_dirt": "Tierra infértil",
  "block.minecraft.cobbled_deepslate": "Adoquín de pizarra profunda",
  "block.minecraft.cobbled_deepslate_slab": "Baldosa de piedra de pizarra profunda",
  "block.minecraft.cobbled_deepslate_stairs": "Escaleras de piedra de pizarra profunda",
  "block.minecraft.cobbled_deepslate_wall": "Pared de piedra de pizarra profunda",
  "block.minecraft.cobblestone": "Roca",
  "block.minecraft.cobblestone_slab": "Baldosa de roca",
  "block.minecraft.cobblestone_stairs": "Escaleras de roca",
  "block.minecraft.cobblestone_wall": "Pared de roca",
  "block.minecraft.cobweb": "Telaraña",
  "block.minecraft.cocoa": "Cacao",
  "block.minecraft.command_block": "Bloque de comandos",
  "block.minecraft.comparator": "Comparador de redstone",
  "block.minecraft.composter": "Compostera",
  "block.minecraft.conduit": "Canalizador",
  "block.minecraft.copper_bars": "Barras de cobre",
  "block.minecraft.copper_block": "Bloque de cobre",
  "block.minecraft.copper_bulb": "Lámpara de cobre",
  "block.minecraft.copper_chain": "Cadena de cobre",
  "block.minecraft.copper_chest": "Baúl de cobre",
  "block.minecraft.copper_door": "Puerta de cobre",
  "block.minecraft.copper_golem_statue": "Estatua de gólem de cobre",
  "block.minecraft.copper_grate": "Rejilla de cobre",
  "block.minecraft.copper_lantern": "Farol de cobre",
  "block.minecraft.copper_ore": "Mineral de cobre",
  "block.minecraft.copper_torch": "Antorcha de cobre",
  "block.minecraft.copper_trapdoor": "Escotilla de cobre",
  "block.minecraft.copper_wall_torch": "Antorcha de cobre en pared",
  "block.minecraft.cornflower": "Aciano",
  "block.minecraft.cracked_deepslate_bricks": "Ladrillos de pizarra profunda quebrados",
  "block.minecraft.cracked_deepslate_tiles": "Baldosas de pizarra abismal quebradas",
  "block.minecraft.cracked_nether_bricks": "Ladrillos del Nether rajados",
  "block.minecraft.cracked_polished_blackstone_bricks": "Ladrillos de piedra negra pulida rajada",
  "block.minecraft.cracked_stone_bricks": "Ladrillos de piedra rajados",
  "block.minecraft.crafter": "Fabricador",
  "block.minecraft.crafting_table": "Mesa de crafteo",
  "block.minecraft.creaking_heart": "Corazón de crujidor",
  "block.minecraft.creeper_head": "Cabeza de creeper",
  "block.minecraft.creeper_wall_head": "Cabeza de creeper en pared",
  "block.minecraft.crimson_button": "Botón carmesí",
  "block.minecraft.crimson_door": "Puerta carmesí",
  "block.minecraft.crimson_fence": "Reja carmesí",
  "block.minecraft.crimson_fence_gate": "Portón carmesí",
  "block.minecraft.crimson_fungus": "Hongo carmesí",
  "block.minecraft.crimson_hanging_sign": "Cartel colgante carmesí",
  "block.minecraft.crimson_hyphae": "Hifas carmesí",
  "block.minecraft.crimson_nylium": "Nilio carmesí",
  "block.minecraft.crimson_planks": "Madera carmesí",
  "block.minecraft.crimson_pressure_plate": "Placa de presión carmesí",
  "block.minecraft.crimson_roots": "Raíces carmesí",
  "block.minecraft.crimson_shelf": "Estante carmesí",
  "block.minecraft.crimson_sign": "Cartel carmesí",
  "block.minecraft.crimson_slab": "Baldosa carmesí",
  "block.minecraft.crimson_stairs": "Escaleras carmesí",
  "block.minecraft.crimson_stem": "Tallo carmesí",
  "block.minecraft.crimson_trapdoor": "Escotilla carmesí",
  "block.minecraft.crimson_wall_hanging_sign": "Cartel colgante carmesí en pared",
  "block.minecraft.crimson_wall_sign": "Cartel carmesí en pared",
  "block.minecraft.crying_obsidian": "Obsidiana llorosa",
  "block.minecraft.cut_copper": "Cobre cortado",
  "block.minecraft.cut_copper_slab": "Baldosa de cobre cortado",
  "block.minecraft.cut_copper_stairs": "Escaleras de cobre cortado",
  "block.minecraft.cut_red_sandstone": "Arenisca roja cortada",
  "block.minecraft.cut_red_sandstone_slab": "Baldosa de arenisca roja cortada",
  "block.minecraft.cut_sandstone": "Arenisca cortada",
  "block.minecraft.cut_sandstone_slab": "Baldosa de arenisca cortada",
  "block.minecraft.cyan_banner": "Estandarte cian",
  "block.minecraft.cyan_bed": "Cama cian",
  "block.minecraft.cyan_candle": "Vela cian",
  "block.minecraft.cyan_candle_cake": "Torta con vela cian",
  "block.minecraft.cyan_carpet": "Alfombra cian",
  "block.minecraft.cyan_concrete": "Concreto cian",
  "block.minecraft.cyan_concrete_powder": "Cemento cian",
  "block.minecraft.cyan_glazed_terracotta": "Azulejo cian",
  "block.minecraft.cyan_shulker_box": "Caja de shulker cian",
  "block.minecraft.cyan_stained_glass": "Vidrio cian",
  "block.minecraft.cyan_stained_glass_pane": "Panel de vidrio cian",
  "block.minecraft.cyan_terracotta": "Terracota cian",
  "block.minecraft.cyan_wool": "Lana cian",
  "block.minecraft.damaged_anvil": "Yunque muy dañado",
  "block.minecraft.dandelion": "Diente de león",
  "block.minecraft.dark_oak_button": "Botón de roble oscuro",
  "block.minecraft.dark_oak_door": "Puerta de roble oscuro",
  "block.minecraft.dark_oak_fence": "Reja de roble oscuro",
  "block.minecraft.dark_oak_fence_gate": "Portón de roble oscuro",
  "block.minecraft.dark_oak_hanging_sign": "Cartel colgante de roble oscuro",
  "block.minecraft.dark_oak_leaves": "Hojas de roble oscuro",
  "block.minecraft.dark_oak_log": "Tronco de roble oscuro",
  "block.minecraft.dark_oak_planks": "Madera de roble oscuro",
  "block.minecraft.dark_oak_pressure_plate": "Placa de presión de roble oscuro",
  "block.minecraft.dark_oak_sapling": "Brote de roble oscuro",
  "block.minecraft.dark_oak_shelf": "Estante de roble oscuro",
  "block.minecraft.dark_oak_sign": "Cartel de roble oscuro",
  "block.minecraft.dark_oak_slab": "Baldosa de roble oscuro",
  "block.minecraft.dark_oak_stairs": "Escaleras de roble oscuro",
  "block.minecraft.dark_oak_trapdoor": "Escotilla de roble oscuro",
  "block.minecraft.dark_oak_wall_hanging_sign": "Cartel colgante de roble oscuro en pared",
  "block.minecraft.dark_oak_wall_sign": "Cartel de roble oscuro en pared",
  "block.minecraft.dark_oak_wood": "Leño de roble oscuro",
  "block.minecraft.dark_prismarine": "Prismarina oscura",
  "block.minecraft.dark_prismarine_slab": "Baldosa de prismarina oscura",
  "block.minecraft.dark_prismarine_stairs": "Escaleras de prismarina oscura",
  "block.minecraft.daylight_detector": "Sensor de luz solar",
  "block.minecraft.dead_brain_coral": "Coral de cerebro muerto",
  "block.minecraft.dead_brain_coral_block": "Bloque de coral de cerebro muerto",
  "block.minecraft.dead_brain_coral_fan": "Gorgonia de cerebro muerta",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgonia de cerebro muerta en pared",
  "block.minecraft.dead_bubble_coral": "Coral de burbuja muerto",
  "block.minecraft.dead_bubble_coral_block": "Bloque de coral de burbuja muerto",
  "block.minecraft.dead_bubble_coral_fan": "Gorgonia de burbuja muerta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgonia de burbuja muerta en pared",
  "block.minecraft.dead_bush": "Arbusto muerto",
  "block.minecraft.dead_fire_coral": "Coral de fuego muerto",
  "block.minecraft.dead_fire_coral_block": "Bloque de coral de fuego muerto",
  "block.minecraft.dead_fire_coral_fan": "Gorgonia de fuego muerta",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgonia de fuego muerta en pared",
  "block.minecraft.dead_horn_coral": "Coral de cuerno muerto",
  "block.minecraft.dead_horn_coral_block": "Bloque de coral de cuerno muerto",
  "block.minecraft.dead_horn_coral_fan": "Gorgonia de cuerno muerta",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgonia de cuerno muerta en pared",
  "block.minecraft.dead_tube_coral": "Coral de tubo muerto",
  "block.minecraft.dead_tube_coral_block": "Bloque de coral de tubo muerto",
  "block.minecraft.dead_tube_coral_fan": "Gorgonia de tubo muerta",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgonia de tubo muerta en pared",
  "block.minecraft.decorated_pot": "Jarrón decorado",
  "block.minecraft.deepslate": "Pizarra profunda",
  "block.minecraft.deepslate_brick_slab": "Baldosa de ladrillos de pizarra profunda",
  "block.minecraft.deepslate_brick_stairs": "Escaleras de ladrillos de pizarra profunda",
  "block.minecraft.deepslate_brick_wall": "Pared de ladrillos de pizarra profunda",
  "block.minecraft.deepslate_bricks": "Ladrillos de pizarra profunda",
  "block.minecraft.deepslate_coal_ore": "Mineral de carbón de pizarra profunda",
  "block.minecraft.deepslate_copper_ore": "Mineral de cobre de pizarra profunda",
  "block.minecraft.deepslate_diamond_ore": "Mineral de diamante de pizarra profunda",
  "block.minecraft.deepslate_emerald_ore": "Mineral de esmeralda de pizarra profunda",
  "block.minecraft.deepslate_gold_ore": "Mineral de oro de pizarra profunda",
  "block.minecraft.deepslate_iron_ore": "Mineral de hierro de pizarra profunda",
  "block.minecraft.deepslate_lapis_ore": "Mineral de lapislázuli de pizarra profunda",
  "block.minecraft.deepslate_redstone_ore": "Mineral de redstone de pizarra profunda",
  "block.minecraft.deepslate_tile_slab": "Baldosa de losas de pizarra profunda",
  "block.minecraft.deepslate_tile_stairs": "Escaleras de losas de pizarra profunda",
  "block.minecraft.deepslate_tile_wall": "Pared de losas de pizarra profunda",
  "block.minecraft.deepslate_tiles": "Losas de pizarra profunda",
  "block.minecraft.detector_rail": "Vía detectora",
  "block.minecraft.diamond_block": "Bloque de diamante",
  "block.minecraft.diamond_ore": "Mineral de diamante",
  "block.minecraft.diorite": "Diorita",
  "block.minecraft.diorite_slab": "Baldosa de diorita",
  "block.minecraft.diorite_stairs": "Escaleras de diorita",
  "block.minecraft.diorite_wall": "Pared de diorita",
  "block.minecraft.dirt": "Tierra",
  "block.minecraft.dirt_path": "Camino de tierra",
  "block.minecraft.dispenser": "Dispensador",
  "block.minecraft.dragon_egg": "Huevo de dragón",
  "block.minecraft.dragon_head": "Cabeza de dragón",
  "block.minecraft.dragon_wall_head": "Cabeza de dragón en pared",
  "block.minecraft.dried_ghast": "Ghast deshidratado",
  "block.minecraft.dried_kelp_block": "Bloque de algas secas",
  "block.minecraft.dripstone_block": "Bloque de espeleotema",
  "block.minecraft.dropper": "Soltador",
  "block.minecraft.emerald_block": "Bloque de esmeralda",
  "block.minecraft.emerald_ore": "Mineral de esmeralda",
  "block.minecraft.enchanting_table": "Mesa de encantamientos",
  "block.minecraft.end_gateway": "Acceso al End",
  "block.minecraft.end_portal": "Marco del portal al End",
  "block.minecraft.end_portal_frame": "Marco del portal del End",
  "block.minecraft.end_rod": "Vara del End",
  "block.minecraft.end_stone": "Piedra del End",
  "block.minecraft.end_stone_brick_slab": "Baldosa de ladrillos de piedra del End",
  "block.minecraft.end_stone_brick_stairs": "Escaleras de ladrillos de piedra del End",
  "block.minecraft.end_stone_brick_wall": "Pared de ladrillos de piedra del End",
  "block.minecraft.end_stone_bricks": "Ladrillos de piedra del End",
  "block.minecraft.ender_chest": "Baúl de ender",
  "block.minecraft.exposed_chiseled_copper": "Cobre cincelado expuesto",
  "block.minecraft.exposed_copper": "Cobre expuesto",
  "block.minecraft.exposed_copper_bars": "Barras de cobre expuesto",
  "block.minecraft.exposed_copper_bulb": "Lámpara de cobre expuesto",
  "block.minecraft.exposed_copper_chain": "Cadena de cobre expuesto",
  "block.minecraft.exposed_copper_chest": "Baúl de cobre expuesto",
  "block.minecraft.exposed_copper_door": "Puerta de cobre expuesto",
  "block.minecraft.exposed_copper_golem_statue": "Estatua de gólem de cobre expuesto",
  "block.minecraft.exposed_copper_grate": "Rejilla de cobre expuesto",
  "block.minecraft.exposed_copper_lantern": "Farol de cobre expuesto",
  "block.minecraft.exposed_copper_trapdoor": "Escotilla de cobre expuesto",
  "block.minecraft.exposed_cut_copper": "Cobre cortado expuesto",
  "block.minecraft.exposed_cut_copper_slab": "Baldosa de cobre cortado expuesto",
  "block.minecraft.exposed_cut_copper_stairs": "Escaleras de cobre cortado expuesto",
  "block.minecraft.exposed_lightning_rod": "Pararrayos expuesto",
  "block.minecraft.farmland": "Tierra de cultivo",
  "block.minecraft.fern": "Helecho",
  "block.minecraft.fire": "Fuego",
  "block.minecraft.fire_coral": "Coral de fuego",
  "block.minecraft.fire_coral_block": "Bloque de coral de fuego",
  "block.minecraft.fire_coral_fan": "Gorgonia de fuego",
  "block.minecraft.fire_coral_wall_fan": "Gorgonia de fuego en pared",
  "block.minecraft.firefly_bush": "Arbusto con luciérnagas",
  "block.minecraft.fletching_table": "Mesa de arquería",
  "block.minecraft.flower_pot": "Maceta",
  "block.minecraft.flowering_azalea": "Azalea florida",
  "block.minecraft.flowering_azalea_leaves": "Hojas de azalea floridas",
  "block.minecraft.frogspawn": "Desove de rana",
  "block.minecraft.frosted_ice": "Hielo escarchado",
  "block.minecraft.furnace": "Horno",
  "block.minecraft.gilded_blackstone": "Piedra negra dorada",
  "block.minecraft.glass": "Vidrio",
  "block.minecraft.glass_pane": "Panel de vidrio",
  "block.minecraft.glow_lichen": "Liquen luminoso",
  "block.minecraft.glowstone": "Piedra luminosa",
  "block.minecraft.gold_block": "Bloque de oro",
  "block.minecraft.gold_ore": "Mineral de oro",
  "block.minecraft.golden_dandelion": "Diente de león dorado",
  "block.minecraft.granite": "Granito",
  "block.minecraft.granite_slab": "Baldosa de granito",
  "block.minecraft.granite_stairs": "Escaleras de granito",
  "block.minecraft.granite_wall": "Pared de granito",
  "block.minecraft.grass": "Pasto",
  "block.minecraft.grass_block": "Bloque de pasto",
  "block.minecraft.gravel": "Grava",
  "block.minecraft.gray_banner": "Estandarte gris",
  "block.minecraft.gray_bed": "Cama gris",
  "block.minecraft.gray_candle": "Vela gris",
  "block.minecraft.gray_candle_cake": "Torta con vela gris",
  "block.minecraft.gray_carpet": "Alfombra gris",
  "block.minecraft.gray_concrete": "Concreto gris",
  "block.minecraft.gray_concrete_powder": "Cemento gris",
  "block.minecraft.gray_glazed_terracotta": "Azulejo gris",
  "block.minecraft.gray_shulker_box": "Caja de shulker gris",
  "block.minecraft.gray_stained_glass": "Vidrio gris",
  "block.minecraft.gray_stained_glass_pane": "Panel de vidrio gris",
  "block.minecraft.gray_terracotta": "Terracota gris",
  "block.minecraft.gray_wool": "Lana gris",
  "block.minecraft.green_banner": "Estandarte verde",
  "block.minecraft.green_bed": "Cama verde",
  "block.minecraft.green_candle": "Vela verde",
  "block.minecraft.green_candle_cake": "Torta con vela verde",
  "block.minecraft.green_carpet": "Alfombra verde",
  "block.minecraft.green_concrete": "Concreto verde",
  "block.minecraft.green_concrete_powder": "Cemento verde",
  "block.minecraft.green_glazed_terracotta": "Azulejo verde",
  "block.minecraft.green_shulker_box": "Caja de shulker verde",
  "block.minecraft.green_stained_glass": "Vidrio verde",
  "block.minecraft.green_stained_glass_pane": "Panel de vidrio verde",
  "block.minecraft.green_terracotta": "Terracota verde",
  "block.minecraft.green_wool": "Lana verde",
  "block.minecraft.grindstone": "Afiladora",
  "block.minecraft.hanging_roots": "Raíces colgantes",
  "block.minecraft.hay_block": "Heno",
  "block.minecraft.heavy_core": "Núcleo pesado",
  "block.minecraft.heavy_weighted_pressure_plate": "Placa de presión para peso elevado",
  "block.minecraft.honey_block": "Bloque de miel",
  "block.minecraft.honeycomb_block": "Bloque de panal",
  "block.minecraft.hopper": "Tolva",
  "block.minecraft.horn_coral": "Coral de cuerno",
  "block.minecraft.horn_coral_block": "Bloque de coral de cuerno",
  "block.minecraft.horn_coral_fan": "Gorgonia de cuerno",
  "block.minecraft.horn_coral_wall_fan": "Gorgonia de cuerno en pared",
  "block.minecraft.ice": "Hielo",
  "block.minecraft.infested_chiseled_stone_bricks": "Ladrillos de piedra cincelados infestados",
  "block.minecraft.infested_cobblestone": "Roca infestada",
  "block.minecraft.infested_cracked_stone_bricks": "Ladrillos de piedra rajados infestados",
  "block.minecraft.infested_deepslate": "Pizarra profunda infestada",
  "block.minecraft.infested_mossy_stone_bricks": "Ladrillos de piedra musgosos infestados",
  "block.minecraft.infested_stone": "Piedra infestada",
  "block.minecraft.infested_stone_bricks": "Ladrillos de piedra infestados",
  "block.minecraft.iron_bars": "Barras de hierro",
  "block.minecraft.iron_block": "Bloque de hierro",
  "block.minecraft.iron_chain": "Cadena de hierro",
  "block.minecraft.iron_door": "Puerta de hierro",
  "block.minecraft.iron_ore": "Mineral de hierro",
  "block.minecraft.iron_trapdoor": "Escotilla de hierro",
  "block.minecraft.jack_o_lantern": "Zapallo de Halloween",
  "block.minecraft.jigsaw": "Bloque de rompecabezas",
  "block.minecraft.jukebox": "Tocadiscos",
  "block.minecraft.jungle_button": "Botón de jungla",
  "block.minecraft.jungle_door": "Puerta de jungla",
  "block.minecraft.jungle_fence": "Reja de jungla",
  "block.minecraft.jungle_fence_gate": "Portón de jungla",
  "block.minecraft.jungle_hanging_sign": "Cartel colgante de jungla",
  "block.minecraft.jungle_leaves": "Hojas de jungla",
  "block.minecraft.jungle_log": "Tronco de jungla",
  "block.minecraft.jungle_planks": "Madera de jungla",
  "block.minecraft.jungle_pressure_plate": "Placa de presión de jungla",
  "block.minecraft.jungle_sapling": "Brote de jungla",
  "block.minecraft.jungle_shelf": "Estante de jungla",
  "block.minecraft.jungle_sign": "Cartel de jungla",
  "block.minecraft.jungle_slab": "Baldosa de jungla",
  "block.minecraft.jungle_stairs": "Escaleras de jungla",
  "block.minecraft.jungle_trapdoor": "Escotilla de jungla",
  "block.minecraft.jungle_wall_hanging_sign": "Cartel colgante de jungla en pared",
  "block.minecraft.jungle_wall_sign": "Cartel de jungla en pared",
  "block.minecraft.jungle_wood": "Leño de jungla",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Tallo de alga",
  "block.minecraft.ladder": "Escalera",
  "block.minecraft.lantern": "Farol",
  "block.minecraft.lapis_block": "Bloque de Lapislázuli",
  "block.minecraft.lapis_ore": "Mineral de lapislázuli",
  "block.minecraft.large_amethyst_bud": "Brote de amatista grande",
  "block.minecraft.large_fern": "Helecho alto",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Caldero con lava",
  "block.minecraft.leaf_litter": "Hojas secas",
  "block.minecraft.lectern": "Atril",
  "block.minecraft.lever": "Palanca",
  "block.minecraft.light": "Luz",
  "block.minecraft.light_blue_banner": "Estandarte celeste",
  "block.minecraft.light_blue_bed": "Cama celeste",
  "block.minecraft.light_blue_candle": "Vela celeste",
  "block.minecraft.light_blue_candle_cake": "Torta con vela celeste",
  "block.minecraft.light_blue_carpet": "Alfombra celeste",
  "block.minecraft.light_blue_concrete": "Concreto celeste",
  "block.minecraft.light_blue_concrete_powder": "Cemento celeste",
  "block.minecraft.light_blue_glazed_terracotta": "Azulejo celeste",
  "block.minecraft.light_blue_shulker_box": "Caja de shulker celeste",
  "block.minecraft.light_blue_stained_glass": "Vidrio celeste",
  "block.minecraft.light_blue_stained_glass_pane": "Panel de vidrio celeste",
  "block.minecraft.light_blue_terracotta": "Terracota celeste",
  "block.minecraft.light_blue_wool": "Lana celeste",
  "block.minecraft.light_gray_banner": "Estandarte gris claro",
  "block.minecraft.light_gray_bed": "Cama gris claro",
  "block.minecraft.light_gray_candle": "Vela gris claro",
  "block.minecraft.light_gray_candle_cake": "Torta con vela gris claro",
  "block.minecraft.light_gray_carpet": "Alfombra gris claro",
  "block.minecraft.light_gray_concrete": "Concreto gris claro",
  "block.minecraft.light_gray_concrete_powder": "Cemento gris claro",
  "block.minecraft.light_gray_glazed_terracotta": "Azulejo gris claro",
  "block.minecraft.light_gray_shulker_box": "Caja de shulker gris claro",
  "block.minecraft.light_gray_stained_glass": "Vidrio gris claro",
  "block.minecraft.light_gray_stained_glass_pane": "Panel de vidrio gris claro",
  "block.minecraft.light_gray_terracotta": "Terracota gris claro",
  "block.minecraft.light_gray_wool": "Lana gris claro",
  "block.minecraft.light_weighted_pressure_plate": "Placa de presión para peso liviano",
  "block.minecraft.lightning_rod": "Pararrayos",
  "block.minecraft.lilac": "Lila",
  "block.minecraft.lily_of_the_valley": "Lirio del valle",
  "block.minecraft.lily_pad": "Nenúfar",
  "block.minecraft.lime_banner": "Estandarte verde lima",
  "block.minecraft.lime_bed": "Cama verde lima",
  "block.minecraft.lime_candle": "Vela verde lima",
  "block.minecraft.lime_candle_cake": "Torta con vela verde lima",
  "block.minecraft.lime_carpet": "Alfombra verde lima",
  "block.minecraft.lime_concrete": "Concreto verde lima",
  "block.minecraft.lime_concrete_powder": "Cemento verde lima",
  "block.minecraft.lime_glazed_terracotta": "Azulejo verde lima",
  "block.minecraft.lime_shulker_box": "Caja de shulker verde lima",
  "block.minecraft.lime_stained_glass": "Vidrio verde lima",
  "block.minecraft.lime_stained_glass_pane": "Panel de vidrio verde lima",
  "block.minecraft.lime_terracotta": "Terracota verde lima",
  "block.minecraft.lime_wool": "Lana verde lima",
  "block.minecraft.lodestone": "Magnetita",
  "block.minecraft.loom": "Máquina de telar",
  "block.minecraft.magenta_banner": "Estandarte magenta",
  "block.minecraft.magenta_bed": "Cama magenta",
  "block.minecraft.magenta_candle": "Vela magenta",
  "block.minecraft.magenta_candle_cake": "Torta con vela magenta",
  "block.minecraft.magenta_carpet": "Alfombra magenta",
  "block.minecraft.magenta_concrete": "Concreto magenta",
  "block.minecraft.magenta_concrete_powder": "Cemento magenta",
  "block.minecraft.magenta_glazed_terracotta": "Azulejo magenta",
  "block.minecraft.magenta_shulker_box": "Caja de shulker magenta",
  "block.minecraft.magenta_stained_glass": "Vidrio magenta",
  "block.minecraft.magenta_stained_glass_pane": "Panel de vidrio magenta",
  "block.minecraft.magenta_terracotta": "Terracota magenta",
  "block.minecraft.magenta_wool": "Lana magenta",
  "block.minecraft.magma_block": "Bloque de magma",
  "block.minecraft.mangrove_button": "Botón de mangle",
  "block.minecraft.mangrove_door": "Puerta de mangle",
  "block.minecraft.mangrove_fence": "Reja de mangle",
  "block.minecraft.mangrove_fence_gate": "Portón de mangle",
  "block.minecraft.mangrove_hanging_sign": "Cartel colgante de mangle",
  "block.minecraft.mangrove_leaves": "Hojas de mangle",
  "block.minecraft.mangrove_log": "Tronco de mangle",
  "block.minecraft.mangrove_planks": "Madera de mangle",
  "block.minecraft.mangrove_pressure_plate": "Placa de presión de mangle",
  "block.minecraft.mangrove_propagule": "Propágulo de mangle",
  "block.minecraft.mangrove_roots": "Raíces de mangle",
  "block.minecraft.mangrove_shelf": "Estante de mangle",
  "block.minecraft.mangrove_sign": "Cartel de mangle",
  "block.minecraft.mangrove_slab": "Baldosa de mangle",
  "block.minecraft.mangrove_stairs": "Escaleras de mangle",
  "block.minecraft.mangrove_trapdoor": "Escotilla de mangle",
  "block.minecraft.mangrove_wall_hanging_sign": "Cartel colgante de mangle en pared",
  "block.minecraft.mangrove_wall_sign": "Cartel de mangle en pared",
  "block.minecraft.mangrove_wood": "Leño de mangle",
  "block.minecraft.medium_amethyst_bud": "Brote de amatista mediano",
  "block.minecraft.melon": "Sandía",
  "block.minecraft.melon_stem": "Tallo de sandía",
  "block.minecraft.moss_block": "Bloque de musgo",
  "block.minecraft.moss_carpet": "Alfombra de musgo",
  "block.minecraft.mossy_cobblestone": "Roca musgosa",
  "block.minecraft.mossy_cobblestone_slab": "Baldosa de roca musgosa",
  "block.minecraft.mossy_cobblestone_stairs": "Escaleras de roca musgosa",
  "block.minecraft.mossy_cobblestone_wall": "Pared de roca musgosa",
  "block.minecraft.mossy_stone_brick_slab": "Baldosa de ladrillos de piedra musgosos",
  "block.minecraft.mossy_stone_brick_stairs": "Escaleras de ladrillos de piedra musgosos",
  "block.minecraft.mossy_stone_brick_wall": "Pared de ladrillos de piedra musgosa",
  "block.minecraft.mossy_stone_bricks": "Ladrillos de piedra musgosos",
  "block.minecraft.moving_piston": "Pistón en movimiento",
  "block.minecraft.mud": "Barro",
  "block.minecraft.mud_brick_slab": "Baldosa de ladrillos de adobe",
  "block.minecraft.mud_brick_stairs": "Escaleras de ladrillos de adobe",
  "block.minecraft.mud_brick_wall": "Pared de ladrillos de adobe",
  "block.minecraft.mud_bricks": "Ladrillos de adobe",
  "block.minecraft.muddy_mangrove_roots": "Raíces de mangle con barro",
  "block.minecraft.mushroom_stem": "Tallo de hongo",
  "block.minecraft.mycelium": "Micelio",
  "block.minecraft.nether_brick_fence": "Reja de ladrillos del Nether",
  "block.minecraft.nether_brick_slab": "Baldosa de ladrillos del Nether",
  "block.minecraft.nether_brick_stairs": "Escaleras de ladrillos del Nether",
  "block.minecraft.nether_brick_wall": "Pared de ladrillos del Nether",
  "block.minecraft.nether_bricks": "Ladrillos del Nether",
  "block.minecraft.nether_gold_ore": "Mineral de oro del Nether",
  "block.minecraft.nether_portal": "Portal del Nether",
  "block.minecraft.nether_quartz_ore": "Mineral de cuarzo del Nether",
  "block.minecraft.nether_sprouts": "Brotes del Nether",
  "block.minecraft.nether_wart": "Verruga del Nether",
  "block.minecraft.nether_wart_block": "Bloque de verrugas del Nether",
  "block.minecraft.netherite_block": "Bloque de netherita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloque musical",
  "block.minecraft.oak_button": "Botón de roble",
  "block.minecraft.oak_door": "Puerta de roble",
  "block.minecraft.oak_fence": "Reja de roble",
  "block.minecraft.oak_fence_gate": "Portón de roble",
  "block.minecraft.oak_hanging_sign": "Cartel colgante de roble",
  "block.minecraft.oak_leaves": "Hojas de roble",
  "block.minecraft.oak_log": "Tronco de roble",
  "block.minecraft.oak_planks": "Madera de roble",
  "block.minecraft.oak_pressure_plate": "Placa de presión de roble",
  "block.minecraft.oak_sapling": "Brote de roble",
  "block.minecraft.oak_shelf": "Estante de roble",
  "block.minecraft.oak_sign": "Cartel de roble",
  "block.minecraft.oak_slab": "Baldosa de roble",
  "block.minecraft.oak_stairs": "Escaleras de roble",
  "block.minecraft.oak_trapdoor": "Escotilla de roble",
  "block.minecraft.oak_wall_hanging_sign": "Cartel colgante de roble en pared",
  "block.minecraft.oak_wall_sign": "Cartel de roble en pared",
  "block.minecraft.oak_wood": "Leño de roble",
  "block.minecraft.observer": "Observador",
  "block.minecraft.obsidian": "Obsidiana",
  "block.minecraft.ochre_froglight": "Ranaluz ocre",
  "block.minecraft.ominous_banner": "Estandarte siniestro",
  "block.minecraft.open_eyeblossom": "Miraflor abierta",
  "block.minecraft.orange_banner": "Estandarte naranja",
  "block.minecraft.orange_bed": "Cama naranja",
  "block.minecraft.orange_candle": "Vela naranja",
  "block.minecraft.orange_candle_cake": "Torta con vela naranja",
  "block.minecraft.orange_carpet": "Alfombra naranja",
  "block.minecraft.orange_concrete": "Concreto naranja",
  "block.minecraft.orange_concrete_powder": "Cemento naranja",
  "block.minecraft.orange_glazed_terracotta": "Azulejo naranja",
  "block.minecraft.orange_shulker_box": "Caja de shulker naranja",
  "block.minecraft.orange_stained_glass": "Vidrio naranja",
  "block.minecraft.orange_stained_glass_pane": "Panel de vidrio naranja",
  "block.minecraft.orange_terracotta": "Terracota naranja",
  "block.minecraft.orange_tulip": "Tulipán naranja",
  "block.minecraft.orange_wool": "Lana naranja",
  "block.minecraft.oxeye_daisy": "Margarita",
  "block.minecraft.oxidized_chiseled_copper": "Cobre cincelado oxidado",
  "block.minecraft.oxidized_copper": "Cobre oxidado",
  "block.minecraft.oxidized_copper_bars": "Barras de cobre oxidado",
  "block.minecraft.oxidized_copper_bulb": "Lámpara de cobre oxidado",
  "block.minecraft.oxidized_copper_chain": "Cadena de cobre oxidado",
  "block.minecraft.oxidized_copper_chest": "Baúl de cobre oxidado",
  "block.minecraft.oxidized_copper_door": "Puerta de cobre oxidado",
  "block.minecraft.oxidized_copper_golem_statue": "Estatua de gólem de cobre oxidado",
  "block.minecraft.oxidized_copper_grate": "Rejilla de cobre oxidado",
  "block.minecraft.oxidized_copper_lantern": "Farol de cobre oxidado",
  "block.minecraft.oxidized_copper_trapdoor": "Escotilla de cobre oxidado",
  "block.minecraft.oxidized_cut_copper": "Cobre cortado oxidado",
  "block.minecraft.oxidized_cut_copper_slab": "Baldosa de cobre cortado oxidado",
  "block.minecraft.oxidized_cut_copper_stairs": "Escaleras de cobre cortado oxidado",
  "block.minecraft.oxidized_lightning_rod": "Pararrayos oxidado",
  "block.minecraft.packed_ice": "Hielo comprimido",
  "block.minecraft.packed_mud": "Adobe",
  "block.minecraft.pale_hanging_moss": "Musgo pálido colgante",
  "block.minecraft.pale_moss_block": "Bloque de musgo pálido",
  "block.minecraft.pale_moss_carpet": "Alfombra de musgo pálido",
  "block.minecraft.pale_oak_button": "Botón de roble pálido",
  "block.minecraft.pale_oak_door": "Puerta de roble pálido",
  "block.minecraft.pale_oak_fence": "Reja de roble pálido",
  "block.minecraft.pale_oak_fence_gate": "Portón de roble pálido",
  "block.minecraft.pale_oak_hanging_sign": "Cartel colgante de roble pálido",
  "block.minecraft.pale_oak_leaves": "Hojas de roble pálido",
  "block.minecraft.pale_oak_log": "Tronco de roble pálido",
  "block.minecraft.pale_oak_planks": "Madera de roble pálido",
  "block.minecraft.pale_oak_pressure_plate": "Placa de presión de roble pálido",
  "block.minecraft.pale_oak_sapling": "Brote de roble pálido",
  "block.minecraft.pale_oak_shelf": "Estante de roble pálido",
  "block.minecraft.pale_oak_sign": "Cartel de roble pálido",
  "block.minecraft.pale_oak_slab": "Baldosa de roble pálido",
  "block.minecraft.pale_oak_stairs": "Escaleras de roble pálido",
  "block.minecraft.pale_oak_trapdoor": "Escotilla de roble pálido",
  "block.minecraft.pale_oak_wall_hanging_sign": "Cartel colgante de roble pálido en pared",
  "block.minecraft.pale_oak_wall_sign": "Cartel de roble pálido en pared",
  "block.minecraft.pale_oak_wood": "Leño de roble pálido",
  "block.minecraft.pearlescent_froglight": "Ranaluz nacarada",
  "block.minecraft.peony": "Peonía",
  "block.minecraft.petrified_oak_slab": "Baldosa de roble petrificada",
  "block.minecraft.piglin_head": "Cabeza de piglin",
  "block.minecraft.piglin_wall_head": "Cabeza de piglin en pared",
  "block.minecraft.pink_banner": "Estandarte rosa",
  "block.minecraft.pink_bed": "Cama rosa",
  "block.minecraft.pink_candle": "Vela rosa",
  "block.minecraft.pink_candle_cake": "Torta con vela rosa",
  "block.minecraft.pink_carpet": "Alfombra rosa",
  "block.minecraft.pink_concrete": "Concreto rosa",
  "block.minecraft.pink_concrete_powder": "Cemento rosa",
  "block.minecraft.pink_glazed_terracotta": "Azulejo rosa",
  "block.minecraft.pink_petals": "Pétalos rosas",
  "block.minecraft.pink_shulker_box": "Caja de shulker rosa",
  "block.minecraft.pink_stained_glass": "Vidrio rosa",
  "block.minecraft.pink_stained_glass_pane": "Panel de vidrio rosa",
  "block.minecraft.pink_terracotta": "Terracota rosa",
  "block.minecraft.pink_tulip": "Tulipán rosa",
  "block.minecraft.pink_wool": "Lana rosa",
  "block.minecraft.piston": "Pistón",
  "block.minecraft.piston_head": "Cabeza de pistón",
  "block.minecraft.pitcher_crop": "Cultivo de planta jarra",
  "block.minecraft.pitcher_plant": "Planta jarra",
  "block.minecraft.player_head": "Cabeza de jugador",
  "block.minecraft.player_head.named": "Cabeza de %s",
  "block.minecraft.player_wall_head": "Cabeza de jugador en pared",
  "block.minecraft.podzol": "Podsol",
  "block.minecraft.pointed_dripstone": "Espeleotema puntiagudo",
  "block.minecraft.polished_andesite": "Andesita pulida",
  "block.minecraft.polished_andesite_slab": "Baldosa de andesita pulida",
  "block.minecraft.polished_andesite_stairs": "Escaleras de andesita pulida",
  "block.minecraft.polished_basalt": "Basalto pulido",
  "block.minecraft.polished_blackstone": "Piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_slab": "Baldosa de ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_stairs": "Escaleras de ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_wall": "Pared de ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_bricks": "Ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_button": "Botón de piedra negra pulida",
  "block.minecraft.polished_blackstone_pressure_plate": "Placa de presión de piedra negra pulida",
  "block.minecraft.polished_blackstone_slab": "Baldosa de piedra negra pulida",
  "block.minecraft.polished_blackstone_stairs": "Escaleras de piedra negra pulida",
  "block.minecraft.polished_blackstone_wall": "Pared de piedra negra pulida",
  "block.minecraft.polished_deepslate": "Pizarra profunda pulida",
  "block.minecraft.polished_deepslate_slab": "Baldosa de pizarra profunda pulida",
  "block.minecraft.polished_deepslate_stairs": "Escaleras de pizarra profunda pulida",
  "block.minecraft.polished_deepslate_wall": "Pared de pizarra profunda pulida",
  "block.minecraft.polished_diorite": "Diorita pulida",
  "block.minecraft.polished_diorite_slab": "Baldosa de diorita pulida",
  "block.minecraft.polished_diorite_stairs": "Escaleras de diorita pulida",
  "block.minecraft.polished_granite": "Granito pulido",
  "block.minecraft.polished_granite_slab": "Baldosa de granito pulido",
  "block.minecraft.polished_granite_stairs": "Escaleras de granito pulido",
  "block.minecraft.polished_tuff": "Toba pulida",
  "block.minecraft.polished_tuff_slab": "Baldosa de toba pulida",
  "block.minecraft.polished_tuff_stairs": "Escaleras de toba pulida",
  "block.minecraft.polished_tuff_wall": "Pared de toba pulida",
  "block.minecraft.poppy": "Amapola",
  "block.minecraft.potatoes": "Papas",
  "block.minecraft.potted_acacia_sapling": "Maceta con brote de acacia",
  "block.minecraft.potted_allium": "Maceta con allium",
  "block.minecraft.potted_azalea_bush": "Maceta con azalea",
  "block.minecraft.potted_azure_bluet": "Maceta con rubiácea",
  "block.minecraft.potted_bamboo": "Maceta con bambú",
  "block.minecraft.potted_birch_sapling": "Maceta con brote de abedul",
  "block.minecraft.potted_blue_orchid": "Maceta con orquídea azul",
  "block.minecraft.potted_brown_mushroom": "Maceta con hongo marrón",
  "block.minecraft.potted_cactus": "Maceta con cactus",
  "block.minecraft.potted_cherry_sapling": "Maceta con brote de cerezo",
  "block.minecraft.potted_closed_eyeblossom": "Maceta con miraflor cerrada",
  "block.minecraft.potted_cornflower": "Maceta con aciano",
  "block.minecraft.potted_crimson_fungus": "Maceta con hongo carmesí",
  "block.minecraft.potted_crimson_roots": "Maceta con raíces carmesí",
  "block.minecraft.potted_dandelion": "Maceta con diente de león",
  "block.minecraft.potted_dark_oak_sapling": "Maceta con brote de roble oscuro",
  "block.minecraft.potted_dead_bush": "Maceta con arbusto muerto",
  "block.minecraft.potted_fern": "Maceta con helecho",
  "block.minecraft.potted_flowering_azalea_bush": "Maceta con azalea florida",
  "block.minecraft.potted_golden_dandelion": "Maceta con diente de león dorado",
  "block.minecraft.potted_jungle_sapling": "Maceta con brote de jungla",
  "block.minecraft.potted_lily_of_the_valley": "Maceta con lirio del valle",
  "block.minecraft.potted_mangrove_propagule": "Maceta con propágulo de mangle",
  "block.minecraft.potted_oak_sapling": "Maceta con brote de roble",
  "block.minecraft.potted_open_eyeblossom": "Maceta con miraflor abierta",
  "block.minecraft.potted_orange_tulip": "Maceta con tulipán naranja",
  "block.minecraft.potted_oxeye_daisy": "Maceta con margarita",
  "block.minecraft.potted_pale_oak_sapling": "Maceta con brote de roble pálido",
  "block.minecraft.potted_pink_tulip": "Maceta con tulipán rosa",
  "block.minecraft.potted_poppy": "Maceta con amapola",
  "block.minecraft.potted_red_mushroom": "Maceta con hongo rojo",
  "block.minecraft.potted_red_tulip": "Maceta con tulipán rojo",
  "block.minecraft.potted_spruce_sapling": "Maceta con brote de pino",
  "block.minecraft.potted_torchflower": "Maceta con anflorcha",
  "block.minecraft.potted_warped_fungus": "Maceta con hongo distorsionado",
  "block.minecraft.potted_warped_roots": "Maceta con raíces distorsionadas",
  "block.minecraft.potted_white_tulip": "Maceta con tulipán blanco",
  "block.minecraft.potted_wither_rose": "Maceta con rosa del Wither",
  "block.minecraft.powder_snow": "Nieve polvo",
  "block.minecraft.powder_snow_cauldron": "Caldero con nieve polvo",
  "block.minecraft.powered_rail": "Vía propulsora",
  "block.minecraft.prismarine": "Prismarina",
  "block.minecraft.prismarine_brick_slab": "Baldosa de ladrillos de prismarina",
  "block.minecraft.prismarine_brick_stairs": "Escaleras de ladrillos de prismarina",
  "block.minecraft.prismarine_bricks": "Ladrillos de prismarina",
  "block.minecraft.prismarine_slab": "Baldosa de prismarina",
  "block.minecraft.prismarine_stairs": "Escaleras de prismarina",
  "block.minecraft.prismarine_wall": "Pared de prismarina",
  "block.minecraft.pumpkin": "Zapallo",
  "block.minecraft.pumpkin_stem": "Tallo de zapallo",
  "block.minecraft.purple_banner": "Estandarte violeta",
  "block.minecraft.purple_bed": "Cama violeta",
  "block.minecraft.purple_candle": "Vela violeta",
  "block.minecraft.purple_candle_cake": "Torta con vela violeta",
  "block.minecraft.purple_carpet": "Alfombra violeta",
  "block.minecraft.purple_concrete": "Concreto violeta",
  "block.minecraft.purple_concrete_powder": "Cemento violeta",
  "block.minecraft.purple_glazed_terracotta": "Azulejo violeta",
  "block.minecraft.purple_shulker_box": "Caja de shulker violeta",
  "block.minecraft.purple_stained_glass": "Vidrio violeta",
  "block.minecraft.purple_stained_glass_pane": "Panel de vidrio violeta",
  "block.minecraft.purple_terracotta": "Terracota violeta",
  "block.minecraft.purple_wool": "Lana violeta",
  "block.minecraft.purpur_block": "Purpur",
  "block.minecraft.purpur_pillar": "Pilar de purpur",
  "block.minecraft.purpur_slab": "Baldosa de purpur",
  "block.minecraft.purpur_stairs": "Escaleras de purpur",
  "block.minecraft.quartz_block": "Cuarzo",
  "block.minecraft.quartz_bricks": "Ladrillos de cuarzo",
  "block.minecraft.quartz_pillar": "Pilar de cuarzo",
  "block.minecraft.quartz_slab": "Baldosa de cuarzo",
  "block.minecraft.quartz_stairs": "Escaleras de cuarzo",
  "block.minecraft.rail": "Vía",
  "block.minecraft.raw_copper_block": "Bloque de cobre crudo",
  "block.minecraft.raw_gold_block": "Bloque de oro crudo",
  "block.minecraft.raw_iron_block": "Bloque de hierro crudo",
  "block.minecraft.red_banner": "Estandarte rojo",
  "block.minecraft.red_bed": "Cama roja",
  "block.minecraft.red_candle": "Vela roja",
  "block.minecraft.red_candle_cake": "Torta con vela roja",
  "block.minecraft.red_carpet": "Alfombra roja",
  "block.minecraft.red_concrete": "Concreto rojo",
  "block.minecraft.red_concrete_powder": "Cemento rojo",
  "block.minecraft.red_glazed_terracotta": "Azulejo rojo",
  "block.minecraft.red_mushroom": "Hongo rojo",
  "block.minecraft.red_mushroom_block": "Bloque de hongo rojo",
  "block.minecraft.red_nether_brick_slab": "Baldosa de ladrillos del Nether rojos",
  "block.minecraft.red_nether_brick_stairs": "Escaleras de ladrillos del Nether rojos",
  "block.minecraft.red_nether_brick_wall": "Pared de ladrillos del Nether rojos",
  "block.minecraft.red_nether_bricks": "Ladrillos del Nether rojos",
  "block.minecraft.red_sand": "Arena roja",
  "block.minecraft.red_sandstone": "Arenisca roja",
  "block.minecraft.red_sandstone_slab": "Baldosa de arenisca roja",
  "block.minecraft.red_sandstone_stairs": "Escaleras de arenisca roja",
  "block.minecraft.red_sandstone_wall": "Pared de arenisca roja",
  "block.minecraft.red_shulker_box": "Caja de shulker roja",
  "block.minecraft.red_stained_glass": "Vidrio rojo",
  "block.minecraft.red_stained_glass_pane": "Panel de vidrio rojo",
  "block.minecraft.red_terracotta": "Terracota roja",
  "block.minecraft.red_tulip": "Tulipán rojo",
  "block.minecraft.red_wool": "Lana roja",
  "block.minecraft.redstone_block": "Bloque de redstone",
  "block.minecraft.redstone_lamp": "Lámpara de redstone",
  "block.minecraft.redstone_ore": "Mineral de redstone",
  "block.minecraft.redstone_torch": "Antorcha de redstone",
  "block.minecraft.redstone_wall_torch": "Antorcha de redstone en pared",
  "block.minecraft.redstone_wire": "Cable de redstone",
  "block.minecraft.reinforced_deepslate": "Pizarra profunda reforzada",
  "block.minecraft.repeater": "Repetidor de redstone",
  "block.minecraft.repeating_command_block": "Bloque de comandos de repetición",
  "block.minecraft.resin_block": "Bloque de resina",
  "block.minecraft.resin_brick_slab": "Baldosa de ladrillos de resina",
  "block.minecraft.resin_brick_stairs": "Escalera de ladrillos de resina",
  "block.minecraft.resin_brick_wall": "Pared de ladrillos de resina",
  "block.minecraft.resin_bricks": "Ladrillo de resina",
  "block.minecraft.resin_clump": "Bloque de resina",
  "block.minecraft.respawn_anchor": "Nexo de reaparición",
  "block.minecraft.rooted_dirt": "Tierra enraizada",
  "block.minecraft.rose_bush": "Rosal",
  "block.minecraft.sand": "Arena",
  "block.minecraft.sandstone": "Arenisca",
  "block.minecraft.sandstone_slab": "Baldosa de arenisca",
  "block.minecraft.sandstone_stairs": "Escaleras de arenisca",
  "block.minecraft.sandstone_wall": "Pared de arenisca",
  "block.minecraft.scaffolding": "Andamio",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalizador de sculk",
  "block.minecraft.sculk_sensor": "Sensor de sculk",
  "block.minecraft.sculk_shrieker": "Chillador de sculk",
  "block.minecraft.sculk_vein": "Vena de sculk",
  "block.minecraft.sea_lantern": "Linterna del mar",
  "block.minecraft.sea_pickle": "Pepino de mar",
  "block.minecraft.seagrass": "Planta marina",
  "block.minecraft.set_spawn": "Se estableció el punto de reaparición",
  "block.minecraft.short_dry_grass": "Pasto seco corto",
  "block.minecraft.short_grass": "Pasto corto",
  "block.minecraft.shroomlight": "Honguiluz",
  "block.minecraft.shulker_box": "Caja de shulker",
  "block.minecraft.skeleton_skull": "Cráneo de esqueleto",
  "block.minecraft.skeleton_wall_skull": "Cráneo de esqueleto en pared",
  "block.minecraft.slime_block": "Bloque de slime",
  "block.minecraft.small_amethyst_bud": "Brote de amatista pequeño",
  "block.minecraft.small_dripleaf": "Plantaforma pequeña",
  "block.minecraft.smithing_table": "Mesa de herrería",
  "block.minecraft.smoker": "Ahumador",
  "block.minecraft.smooth_basalt": "Basalto liso",
  "block.minecraft.smooth_quartz": "Cuarzo liso",
  "block.minecraft.smooth_quartz_slab": "Baldosa de cuarzo liso",
  "block.minecraft.smooth_quartz_stairs": "Escaleras de cuarzo liso",
  "block.minecraft.smooth_red_sandstone": "Arenisca roja lisa",
  "block.minecraft.smooth_red_sandstone_slab": "Baldosa de arenisca roja lisa",
  "block.minecraft.smooth_red_sandstone_stairs": "Escaleras de arenisca roja lisa",
  "block.minecraft.smooth_sandstone": "Arenisca lisa",
  "block.minecraft.smooth_sandstone_slab": "Baldosa de arenisca lisa",
  "block.minecraft.smooth_sandstone_stairs": "Escaleras de arenisca lisa",
  "block.minecraft.smooth_stone": "Piedra lisa",
  "block.minecraft.smooth_stone_slab": "Baldosa de piedra lisa",
  "block.minecraft.sniffer_egg": "Huevo de sniffer",
  "block.minecraft.snow": "Nieve",
  "block.minecraft.snow_block": "Bloque de nieve",
  "block.minecraft.soul_campfire": "Fogata de almas",
  "block.minecraft.soul_fire": "Fuego de almas",
  "block.minecraft.soul_lantern": "Farol de almas",
  "block.minecraft.soul_sand": "Arena de almas",
  "block.minecraft.soul_soil": "Tierra de almas",
  "block.minecraft.soul_torch": "Antorcha de almas",
  "block.minecraft.soul_wall_torch": "Antorcha de almas en pared",
  "block.minecraft.spawn.not_valid": "No tenés cama ni nexo de reaparición cargado, o están obstruidos",
  "block.minecraft.spawner": "Generador de criaturas",
  "block.minecraft.spawner.desc1": "Interactuá con un huevo generador:",
  "block.minecraft.spawner.desc2": "Establece el tipo de criatura",
  "block.minecraft.sponge": "Esponja",
  "block.minecraft.spore_blossom": "Flor de esporas",
  "block.minecraft.spruce_button": "Botón de pino",
  "block.minecraft.spruce_door": "Puerta de pino",
  "block.minecraft.spruce_fence": "Reja de pino",
  "block.minecraft.spruce_fence_gate": "Portón de pino",
  "block.minecraft.spruce_hanging_sign": "Cartel colgante de abeto",
  "block.minecraft.spruce_leaves": "Hojas de pino",
  "block.minecraft.spruce_log": "Tronco de pino",
  "block.minecraft.spruce_planks": "Madera de pino",
  "block.minecraft.spruce_pressure_plate": "Placa de presión de pino",
  "block.minecraft.spruce_sapling": "Brote de pino",
  "block.minecraft.spruce_shelf": "Estante de abeto",
  "block.minecraft.spruce_sign": "Cartel de pino",
  "block.minecraft.spruce_slab": "Baldosa de pino",
  "block.minecraft.spruce_stairs": "Escaleras de pino",
  "block.minecraft.spruce_trapdoor": "Escotilla de pino",
  "block.minecraft.spruce_wall_hanging_sign": "Cartel colgante de abeto en pared",
  "block.minecraft.spruce_wall_sign": "Cartel de pino en pared",
  "block.minecraft.spruce_wood": "Leño de pino",
  "block.minecraft.sticky_piston": "Pistón pegajoso",
  "block.minecraft.stone": "Piedra",
  "block.minecraft.stone_brick_slab": "Baldosa de ladrillos de piedra",
  "block.minecraft.stone_brick_stairs": "Escaleras de ladrillos de piedra",
  "block.minecraft.stone_brick_wall": "Pared de ladrillos de piedra",
  "block.minecraft.stone_bricks": "Ladrillos de piedra",
  "block.minecraft.stone_button": "Botón de piedra",
  "block.minecraft.stone_pressure_plate": "Placa de presión de piedra",
  "block.minecraft.stone_slab": "Baldosa de piedra",
  "block.minecraft.stone_stairs": "Escaleras de piedra",
  "block.minecraft.stonecutter": "Cortapiedras",
  "block.minecraft.stripped_acacia_log": "Tronco de acacia sin corteza",
  "block.minecraft.stripped_acacia_wood": "Leño de acacia sin corteza",
  "block.minecraft.stripped_bamboo_block": "Bloque de bambú sin corteza",
  "block.minecraft.stripped_birch_log": "Tronco de abedul sin corteza",
  "block.minecraft.stripped_birch_wood": "Leño de abedul sin corteza",
  "block.minecraft.stripped_cherry_log": "Tronco de cerezo sin corteza",
  "block.minecraft.stripped_cherry_wood": "Leño de cerezo sin corteza",
  "block.minecraft.stripped_crimson_hyphae": "Hifas carmesí sin corteza",
  "block.minecraft.stripped_crimson_stem": "Tallo carmesí sin corteza",
  "block.minecraft.stripped_dark_oak_log": "Tronco de roble oscuro sin corteza",
  "block.minecraft.stripped_dark_oak_wood": "Leño de roble oscuro sin corteza",
  "block.minecraft.stripped_jungle_log": "Tronco de jungla sin corteza",
  "block.minecraft.stripped_jungle_wood": "Leño de jungla sin corteza",
  "block.minecraft.stripped_mangrove_log": "Tronco de mangle sin corteza",
  "block.minecraft.stripped_mangrove_wood": "Leño de mangle sin corteza",
  "block.minecraft.stripped_oak_log": "Tronco de roble sin corteza",
  "block.minecraft.stripped_oak_wood": "Leño de roble sin corteza",
  "block.minecraft.stripped_pale_oak_log": "Tronco de roble pálido sin corteza",
  "block.minecraft.stripped_pale_oak_wood": "Leño de roble pálido sin corteza",
  "block.minecraft.stripped_spruce_log": "Tronco de pino sin corteza",
  "block.minecraft.stripped_spruce_wood": "Leño de pino sin corteza",
  "block.minecraft.stripped_warped_hyphae": "Hifas distorsionadas sin corteza",
  "block.minecraft.stripped_warped_stem": "Tallo distorsionado sin corteza",
  "block.minecraft.structure_block": "Bloque de estructuras",
  "block.minecraft.structure_void": "Vacío de estructuras",
  "block.minecraft.sugar_cane": "Caña de azúcar",
  "block.minecraft.sunflower": "Girasol",
  "block.minecraft.suspicious_gravel": "Grava sospechosa",
  "block.minecraft.suspicious_sand": "Arena sospechosa",
  "block.minecraft.sweet_berry_bush": "Arbusto de bayas dulces",
  "block.minecraft.tall_dry_grass": "Pasto seco alto",
  "block.minecraft.tall_grass": "Pasto alto",
  "block.minecraft.tall_seagrass": "Planta marina alta",
  "block.minecraft.target": "Diana",
  "block.minecraft.terracotta": "Terracota",
  "block.minecraft.test_block": "Bloque de pruebas",
  "block.minecraft.test_instance_block": "Bloque de instancia de prueba",
  "block.minecraft.tinted_glass": "Vidrio opaco",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Las explosiones de TNT están desactivadas",
  "block.minecraft.torch": "Antorcha",
  "block.minecraft.torchflower": "Anflorcha",
  "block.minecraft.torchflower_crop": "Cultivo de anflorcha",
  "block.minecraft.trapped_chest": "Baúl trampa",
  "block.minecraft.trial_spawner": "Generador de desafío",
  "block.minecraft.tripwire": "Hilo trampa",
  "block.minecraft.tripwire_hook": "Gancho de hilo",
  "block.minecraft.tube_coral": "Coral de tubo",
  "block.minecraft.tube_coral_block": "Bloque de coral de tubo",
  "block.minecraft.tube_coral_fan": "Gorgonia de tubo",
  "block.minecraft.tube_coral_wall_fan": "Gorgonia de tubo en pared",
  "block.minecraft.tuff": "Toba",
  "block.minecraft.tuff_brick_slab": "Baldosa de ladrillos de toba",
  "block.minecraft.tuff_brick_stairs": "Escaleras de ladrillos de toba",
  "block.minecraft.tuff_brick_wall": "Pared de ladrillos de toba",
  "block.minecraft.tuff_bricks": "Ladrillos de toba",
  "block.minecraft.tuff_slab": "Baldosa de toba",
  "block.minecraft.tuff_stairs": "Escaleras de toba",
  "block.minecraft.tuff_wall": "Pared de toba",
  "block.minecraft.turtle_egg": "Huevo de tortuga",
  "block.minecraft.twisting_vines": "Enredaderas retorcidas",
  "block.minecraft.twisting_vines_plant": "Enredaderas retorcidas",
  "block.minecraft.vault": "Arca",
  "block.minecraft.verdant_froglight": "Ranaluz verde",
  "block.minecraft.vine": "Enredaderas",
  "block.minecraft.void_air": "Aire del vacío",
  "block.minecraft.wall_torch": "Antorcha en pared",
  "block.minecraft.warped_button": "Botón distorsionado",
  "block.minecraft.warped_door": "Puerta distorsionada",
  "block.minecraft.warped_fence": "Reja distorsionada",
  "block.minecraft.warped_fence_gate": "Portón distorsionado",
  "block.minecraft.warped_fungus": "Hongo distorsionado",
  "block.minecraft.warped_hanging_sign": "Cartel colgante distorsionado",
  "block.minecraft.warped_hyphae": "Hifas distorsionadas",
  "block.minecraft.warped_nylium": "Nilio distorsionado",
  "block.minecraft.warped_planks": "Madera distorsionada",
  "block.minecraft.warped_pressure_plate": "Placa de presión distorsionada",
  "block.minecraft.warped_roots": "Raíces distorsionadas",
  "block.minecraft.warped_shelf": "Estante distorsionado",
  "block.minecraft.warped_sign": "Cartel distorsionado",
  "block.minecraft.warped_slab": "Baldosa distorsionada",
  "block.minecraft.warped_stairs": "Escaleras distorsionadas",
  "block.minecraft.warped_stem": "Tallo distorsionado",
  "block.minecraft.warped_trapdoor": "Escotilla distorsionada",
  "block.minecraft.warped_wall_hanging_sign": "Cartel colgante distorsionado en pared",
  "block.minecraft.warped_wall_sign": "Cartel distorsionado de pared",
  "block.minecraft.warped_wart_block": "Bloque de verrugas distorsionadas",
  "block.minecraft.water": "Agua",
  "block.minecraft.water_cauldron": "Caldero con agua",
  "block.minecraft.waxed_chiseled_copper": "Cobre cincelado encerado",
  "block.minecraft.waxed_copper_bars": "Barras de cobre encerado",
  "block.minecraft.waxed_copper_block": "Bloque de cobre encerado",
  "block.minecraft.waxed_copper_bulb": "Lámpara de cobre encerado",
  "block.minecraft.waxed_copper_chain": "Cadena de cobre encerado",
  "block.minecraft.waxed_copper_chest": "Baúl de cobre encerado",
  "block.minecraft.waxed_copper_door": "Puerta de cobre encerado",
  "block.minecraft.waxed_copper_golem_statue": "Estatua de gólem de cobre encerado",
  "block.minecraft.waxed_copper_grate": "Rejilla de cobre encerado",
  "block.minecraft.waxed_copper_lantern": "Farol de cobre encerado",
  "block.minecraft.waxed_copper_trapdoor": "Escotilla de cobre encerado",
  "block.minecraft.waxed_cut_copper": "Cobre cortado encerado",
  "block.minecraft.waxed_cut_copper_slab": "Baldosa de cobre cortado encerado",
  "block.minecraft.waxed_cut_copper_stairs": "Escaleras de cobre cortado encerado",
  "block.minecraft.waxed_exposed_chiseled_copper": "Cobre cincelado expuesto encerado",
  "block.minecraft.waxed_exposed_copper": "Cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_bars": "Barras de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_bulb": "Lámpara de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_chain": "Cadena de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_chest": "Baúl de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_door": "Puerta de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Estatua de gólem de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_grate": "Rejilla de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_lantern": "Farol de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Escotilla de cobre expuesto encerado",
  "block.minecraft.waxed_exposed_cut_copper": "Cobre cortado expuesto encerado",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Baldosa de cobre cortado expuesto encerado",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Escaleras de cobre cortado expuesto encerado",
  "block.minecraft.waxed_exposed_lightning_rod": "Pararrayos expuesto encerado",
  "block.minecraft.waxed_lightning_rod": "Pararrayos encerado",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Cobre cincelado oxidado encerado",
  "block.minecraft.waxed_oxidized_copper": "Cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_bars": "Barras de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lámpara de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_chain": "Cadena de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_chest": "Baúl de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_door": "Puerta de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Estatua de gólem de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_grate": "Rejilla de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_lantern": "Farol de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Escotilla de cobre oxidado encerado",
  "block.minecraft.waxed_oxidized_cut_copper": "Cobre cortado oxidado encerado",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Baldosa de cobre cortado oxidado encerado",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Escaleras de cobre cortado oxidado encerado",
  "block.minecraft.waxed_oxidized_lightning_rod": "Pararrayos oxidado encerado",
  "block.minecraft.waxed_weathered_chiseled_copper": "Cobre cincelado degradado encerado",
  "block.minecraft.waxed_weathered_copper": "Cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_bars": "Barras de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_bulb": "Lámpara de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_chain": "Cadena de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_chest": "Baúl de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_door": "Puerta de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Estatua de gólem de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_grate": "Rejilla de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_lantern": "Farol de cobre degradado encerado",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Escotilla de cobre degradado encerado",
  "block.minecraft.waxed_weathered_cut_copper": "Cobre cortado degradado encerado",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Baldosa de cobre cortado degradado encerado",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Escaleras de cobre cortado degradado encerado",
  "block.minecraft.waxed_weathered_lightning_rod": "Pararrayos degradado encerado",
  "block.minecraft.weathered_chiseled_copper": "Cobre cincelado degradado",
  "block.minecraft.weathered_copper": "Cobre degradado",
  "block.minecraft.weathered_copper_bars": "Barras de cobre degradado",
  "block.minecraft.weathered_copper_bulb": "Lámpara de cobre degradado",
  "block.minecraft.weathered_copper_chain": "Cadena de cobre degradado",
  "block.minecraft.weathered_copper_chest": "Baúl de cobre degradado",
  "block.minecraft.weathered_copper_door": "Puerta de cobre degradado",
  "block.minecraft.weathered_copper_golem_statue": "Estatua de gólem de cobre degradado",
  "block.minecraft.weathered_copper_grate": "Rejilla de cobre degradado",
  "block.minecraft.weathered_copper_lantern": "Farol de cobre degradado",
  "block.minecraft.weathered_copper_trapdoor": "Escotilla de cobre degradado",
  "block.minecraft.weathered_cut_copper": "Cobre cortado oxidado",
  "block.minecraft.weathered_cut_copper_slab": "Baldosa de cobre cortado oxidado",
  "block.minecraft.weathered_cut_copper_stairs": "Escaleras de cobre cortado oxidado",
  "block.minecraft.weathered_lightning_rod": "Pararrayos degradado",
  "block.minecraft.weeping_vines": "Enredaderas lloronas",
  "block.minecraft.weeping_vines_plant": "Planta de enredaderas lloronas",
  "block.minecraft.wet_sponge": "Esponja húmeda",
  "block.minecraft.wheat": "Cultivo de trigo",
  "block.minecraft.white_banner": "Estandarte blanco",
  "block.minecraft.white_bed": "Cama blanca",
  "block.minecraft.white_candle": "Vela blanca",
  "block.minecraft.white_candle_cake": "Torta con vela blanca",
  "block.minecraft.white_carpet": "Alfombra blanca",
  "block.minecraft.white_concrete": "Concreto blanco",
  "block.minecraft.white_concrete_powder": "Cemento blanco",
  "block.minecraft.white_glazed_terracotta": "Azulejo blanco",
  "block.minecraft.white_shulker_box": "Caja de shulker blanca",
  "block.minecraft.white_stained_glass": "Vidrio blanco",
  "block.minecraft.white_stained_glass_pane": "Panel de vidrio blanco",
  "block.minecraft.white_terracotta": "Terracota blanca",
  "block.minecraft.white_tulip": "Tulipán blanco",
  "block.minecraft.white_wool": "Lana blanca",
  "block.minecraft.wildflowers": "Flores silvestres",
  "block.minecraft.wither_rose": "Rosa del Wither",
  "block.minecraft.wither_skeleton_skull": "Cráneo de esqueleto del Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Cráneo de esqueleto del Wither en pared",
  "block.minecraft.yellow_banner": "Estandarte amarillo",
  "block.minecraft.yellow_bed": "Cama amarilla",
  "block.minecraft.yellow_candle": "Vela amarilla",
  "block.minecraft.yellow_candle_cake": "Torta con vela amarilla",
  "block.minecraft.yellow_carpet": "Alfombra amarilla",
  "block.minecraft.yellow_concrete": "Concreto amarillo",
  "block.minecraft.yellow_concrete_powder": "Cemento amarillo",
  "block.minecraft.yellow_glazed_terracotta": "Azulejo amarillo",
  "block.minecraft.yellow_shulker_box": "Caja de shulker amarilla",
  "block.minecraft.yellow_stained_glass": "Vidrio amarillo",
  "block.minecraft.yellow_stained_glass_pane": "Panel de vidrio amarillo",
  "block.minecraft.yellow_terracotta": "Terracota amarilla",
  "block.minecraft.yellow_wool": "Lana amarilla",
  "block.minecraft.zombie_head": "Cabeza de zombi",
  "block.minecraft.zombie_wall_head": "Cabeza de zombi en pared",
  "item.minecraft.acacia_boat": "Bote de acacia",
  "item.minecraft.acacia_chest_boat": "Bote de acacia con baúl",
  "item.minecraft.allay_spawn_egg": "Generar allay",
  "item.minecraft.amethyst_shard": "Fragmento de amatista",
  "item.minecraft.angler_pottery_shard": "Fragmento de cerámica de pescador",
  "item.minecraft.angler_pottery_sherd": "Fragmento de cerámica de pescador",
  "item.minecraft.apple": "Manzana",
  "item.minecraft.archer_pottery_shard": "Fragmento de cerámica de arquero",
  "item.minecraft.archer_pottery_sherd": "Fragmento de cerámica de arquero",
  "item.minecraft.armadillo_scute": "Escama de armadillo",
  "item.minecraft.armadillo_spawn_egg": "Generar armadillo",
  "item.minecraft.armor_stand": "Soporte para armadura",
  "item.minecraft.arms_up_pottery_shard": "Fragmento de cerámica de brazos arriba",
  "item.minecraft.arms_up_pottery_sherd": "Fragmento de cerámica de gurí",
  "item.minecraft.arrow": "Flecha",
  "item.minecraft.axolotl_bucket": "Balde con ajolote",
  "item.minecraft.axolotl_spawn_egg": "Generar ajolote",
  "item.minecraft.baked_potato": "Papa cocida",
  "item.minecraft.bamboo_chest_raft": "Balsa de bambú con baúl",
  "item.minecraft.bamboo_raft": "Balsa de bambú",
  "item.minecraft.bat_spawn_egg": "Generar murciélago",
  "item.minecraft.bee_spawn_egg": "Generar abeja",
  "item.minecraft.beef": "Carne de vaca cruda",
  "item.minecraft.beetroot": "Remolacha",
  "item.minecraft.beetroot_seeds": "Semillas de remolacha",
  "item.minecraft.beetroot_soup": "Guiso de remolacha",
  "item.minecraft.birch_boat": "Bote de abedul",
  "item.minecraft.birch_chest_boat": "Bote de abedul con baúl",
  "item.minecraft.black_bundle": "Bolsa negra",
  "item.minecraft.black_dye": "Tinte negro",
  "item.minecraft.black_harness": "Arnés negro",
  "item.minecraft.blade_pottery_shard": "Fragmento de cerámica de espada",
  "item.minecraft.blade_pottery_sherd": "Fragmento de cerámica de espada",
  "item.minecraft.blaze_powder": "Polvo de blaze",
  "item.minecraft.blaze_rod": "Vara de blaze",
  "item.minecraft.blaze_spawn_egg": "Generar blaze",
  "item.minecraft.blue_bundle": "Bolsa azul",
  "item.minecraft.blue_dye": "Tinte azul",
  "item.minecraft.blue_egg": "Huevo azul",
  "item.minecraft.blue_harness": "Arnés azul",
  "item.minecraft.bogged_spawn_egg": "Generar esqueleto pantanoso",
  "item.minecraft.bolt_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Adorno de remache",
  "item.minecraft.bone": "Hueso",
  "item.minecraft.bone_meal": "Hueso molido",
  "item.minecraft.book": "Libro",
  "item.minecraft.bordure_indented_banner_pattern": "Estampado de bordura dentada",
  "item.minecraft.bow": "Arco",
  "item.minecraft.bowl": "Cuenco",
  "item.minecraft.bread": "Pan",
  "item.minecraft.breeze_rod": "Vara de breeze",
  "item.minecraft.breeze_spawn_egg": "Generar breeze",
  "item.minecraft.brewer_pottery_shard": "Fragmento de cerámica de poción",
  "item.minecraft.brewer_pottery_sherd": "Fragmento de cerámica de poción",
  "item.minecraft.brewing_stand": "Destiladora",
  "item.minecraft.brick": "Ladrillo",
  "item.minecraft.brown_bundle": "Bolsa marrón",
  "item.minecraft.brown_dye": "Tinte marrón",
  "item.minecraft.brown_egg": "Huevo marrón",
  "item.minecraft.brown_harness": "Arnés marrón",
  "item.minecraft.brush": "Cepillo",
  "item.minecraft.bucket": "Balde",
  "item.minecraft.bundle": "Bolsa",
  "item.minecraft.bundle.empty": "Vacío",
  "item.minecraft.bundle.empty.description": "Puede contener varios objetos",
  "item.minecraft.bundle.full": "Lleno",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Fragmento de cerámica de fuego",
  "item.minecraft.burn_pottery_sherd": "Fragmento de cerámica de fogata",
  "item.minecraft.camel_husk_spawn_egg": "Generar camello momificado",
  "item.minecraft.camel_spawn_egg": "Generar camello",
  "item.minecraft.carrot": "Zanahoria",
  "item.minecraft.carrot_on_a_stick": "Caña con zanahoria",
  "item.minecraft.cat_spawn_egg": "Generar gato",
  "item.minecraft.cauldron": "Caldero",
  "item.minecraft.cave_spider_spawn_egg": "Generar araña de cueva",
  "item.minecraft.chainmail_boots": "Botas de cota de malla",
  "item.minecraft.chainmail_chestplate": "Pechera de cota de malla",
  "item.minecraft.chainmail_helmet": "Casco de cota de malla",
  "item.minecraft.chainmail_leggings": "Pantalones de cota de malla",
  "item.minecraft.charcoal": "Carbón vegetal",
  "item.minecraft.cherry_boat": "Bote de cerezo",
  "item.minecraft.cherry_chest_boat": "Bote de cerezo con baúl",
  "item.minecraft.chest_minecart": "Carrito con baúl",
  "item.minecraft.chicken": "Pollo crudo",
  "item.minecraft.chicken_spawn_egg": "Generar gallina",
  "item.minecraft.chorus_fruit": "Fruta de chorus",
  "item.minecraft.clay_ball": "Bola de arcilla",
  "item.minecraft.clock": "Reloj",
  "item.minecraft.coal": "Carbón",
  "item.minecraft.coast_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Adorno de costa",
  "item.minecraft.cocoa_beans": "Granos de cacao",
  "item.minecraft.cod": "Bacalao crudo",
  "item.minecraft.cod_bucket": "Balde con bacalao",
  "item.minecraft.cod_spawn_egg": "Generar bacalao",
  "item.minecraft.command_block_minecart": "Carrito con bloque de comandos",
  "item.minecraft.compass": "Brújula",
  "item.minecraft.cooked_beef": "Carne de vaca cocinada",
  "item.minecraft.cooked_chicken": "Pollo cocinado",
  "item.minecraft.cooked_cod": "Bacalao cocinado",
  "item.minecraft.cooked_mutton": "Cordero cocinado",
  "item.minecraft.cooked_porkchop": "Chuleta cocinada",
  "item.minecraft.cooked_rabbit": "Conejo cocinado",
  "item.minecraft.cooked_salmon": "Salmón cocinado",
  "item.minecraft.cookie": "Galleta",
  "item.minecraft.copper_axe": "Hacha de cobre",
  "item.minecraft.copper_boots": "Botas de cobre",
  "item.minecraft.copper_chestplate": "Pechera de cobre",
  "item.minecraft.copper_golem_spawn_egg": "Generar gólem de cobre",
  "item.minecraft.copper_helmet": "Casco de cobre",
  "item.minecraft.copper_hoe": "Azada de cobre",
  "item.minecraft.copper_horse_armor": "Armadura de cobre para caballo",
  "item.minecraft.copper_ingot": "Lingote de cobre",
  "item.minecraft.copper_leggings": "Pantalones de cobre",
  "item.minecraft.copper_nautilus_armor": "Armadura de cobre para nautilo",
  "item.minecraft.copper_nugget": "Pepita de cobre",
  "item.minecraft.copper_pickaxe": "Pico de cobre",
  "item.minecraft.copper_shovel": "Pala de cobre",
  "item.minecraft.copper_spear": "Lanza de cobre",
  "item.minecraft.copper_sword": "Espada de cobre",
  "item.minecraft.cow_spawn_egg": "Generar vaca",
  "item.minecraft.creaking_spawn_egg": "Generar crujidor",
  "item.minecraft.creeper_banner_pattern": "Diseño de estandarte",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Estampado de creeper",
  "item.minecraft.creeper_spawn_egg": "Generar creeper",
  "item.minecraft.crossbow": "Ballesta",
  "item.minecraft.crossbow.projectile": "Proyectil:",
  "item.minecraft.crossbow.projectile.multiple": "Proyectil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Proyectil: %s",
  "item.minecraft.cyan_bundle": "Bolsa cian",
  "item.minecraft.cyan_dye": "Tinte cian",
  "item.minecraft.cyan_harness": "Arnés cian",
  "item.minecraft.danger_pottery_shard": "Fragmento de cerámica de peligro",
  "item.minecraft.danger_pottery_sherd": "Fragmento de cerámica de creeper",
  "item.minecraft.dark_oak_boat": "Bote de roble oscuro",
  "item.minecraft.dark_oak_chest_boat": "Bote de roble oscuro con baúl",
  "item.minecraft.debug_stick": "Palo debug",
  "item.minecraft.debug_stick.empty": "%s no tiene propiedades",
  "item.minecraft.debug_stick.select": "seleccionado «%s» (%s)",
  "item.minecraft.debug_stick.update": "«%s» cambió a %s",
  "item.minecraft.diamond": "Diamante",
  "item.minecraft.diamond_axe": "Hacha de diamante",
  "item.minecraft.diamond_boots": "Botas de diamante",
  "item.minecraft.diamond_chestplate": "Pechera de diamante",
  "item.minecraft.diamond_helmet": "Casco de diamante",
  "item.minecraft.diamond_hoe": "Azada de diamante",
  "item.minecraft.diamond_horse_armor": "Armadura de diamante para caballo",
  "item.minecraft.diamond_leggings": "Pantalones de diamante",
  "item.minecraft.diamond_nautilus_armor": "Armadura de diamante para nautilo",
  "item.minecraft.diamond_pickaxe": "Pico de diamante",
  "item.minecraft.diamond_shovel": "Pala de diamante",
  "item.minecraft.diamond_spear": "Lanza de diamante",
  "item.minecraft.diamond_sword": "Espada de diamante",
  "item.minecraft.disc_fragment_5": "Fragmento de disco",
  "item.minecraft.disc_fragment_5.desc": "Disco - 5",
  "item.minecraft.dolphin_spawn_egg": "Generar delfín",
  "item.minecraft.donkey_spawn_egg": "Generar burro",
  "item.minecraft.dragon_breath": "Aliento de dragón",
  "item.minecraft.dried_kelp": "Algas secas",
  "item.minecraft.drowned_spawn_egg": "Generar ahogado",
  "item.minecraft.dune_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Adorno de dunas",
  "item.minecraft.echo_shard": "Fragmento de eco",
  "item.minecraft.egg": "Huevo",
  "item.minecraft.elder_guardian_spawn_egg": "Generar guardián anciano",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Esmeralda",
  "item.minecraft.enchanted_book": "Libro encantado",
  "item.minecraft.enchanted_golden_apple": "Manzana dorada encantada",
  "item.minecraft.end_crystal": "Cristal del End",
  "item.minecraft.ender_dragon_spawn_egg": "Generar Enderdragón",
  "item.minecraft.ender_eye": "Ojo de ender",
  "item.minecraft.ender_pearl": "Perla de ender",
  "item.minecraft.enderman_spawn_egg": "Generar enderman",
  "item.minecraft.endermite_spawn_egg": "Generar endermite",
  "item.minecraft.evoker_spawn_egg": "Generar evocador",
  "item.minecraft.experience_bottle": "Botella de experiencia",
  "item.minecraft.explorer_pottery_shard": "Fragmento de cerámica de explorador",
  "item.minecraft.explorer_pottery_sherd": "Fragmento de cerámica de explorador",
  "item.minecraft.eye_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Adorno de ojo",
  "item.minecraft.feather": "Pluma",
  "item.minecraft.fermented_spider_eye": "Ojo de araña fermentado",
  "item.minecraft.field_masoned_banner_pattern": "Estampado de mazonado",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Carga de fuego",
  "item.minecraft.firework_rocket": "Cohete de fuegos artificiales",
  "item.minecraft.firework_rocket.flight": "Duración del vuelo:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Pólvora de fuegos artificiales",
  "item.minecraft.firework_star.black": "negra",
  "item.minecraft.firework_star.blue": "azul",
  "item.minecraft.firework_star.brown": "marrón",
  "item.minecraft.firework_star.custom_color": "Personalizado",
  "item.minecraft.firework_star.cyan": "cian",
  "item.minecraft.firework_star.fade_to": "Decolora a",
  "item.minecraft.firework_star.flicker": " con chisporroteo.",
  "item.minecraft.firework_star.gray": "gris",
  "item.minecraft.firework_star.green": "verde",
  "item.minecraft.firework_star.light_blue": "celeste",
  "item.minecraft.firework_star.light_gray": "gris claro",
  "item.minecraft.firework_star.lime": "verde lima",
  "item.minecraft.firework_star.magenta": "magenta",
  "item.minecraft.firework_star.orange": "naranja",
  "item.minecraft.firework_star.pink": "rosa",
  "item.minecraft.firework_star.purple": "violeta",
  "item.minecraft.firework_star.red": "roja",
  "item.minecraft.firework_star.shape": "Forma desconocida",
  "item.minecraft.firework_star.shape.burst": "Explosión",
  "item.minecraft.firework_star.shape.creeper": "Con forma de creeper",
  "item.minecraft.firework_star.shape.large_ball": "Esfera grande",
  "item.minecraft.firework_star.shape.small_ball": "Esfera pequeña",
  "item.minecraft.firework_star.shape.star": "Con forma de estrella",
  "item.minecraft.firework_star.trail": " con rastro.",
  "item.minecraft.firework_star.white": "blanca",
  "item.minecraft.firework_star.yellow": "amarilla",
  "item.minecraft.fishing_rod": "Caña de pescar",
  "item.minecraft.flint": "Pedernal",
  "item.minecraft.flint_and_steel": "Encendedor",
  "item.minecraft.flow_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Adorno de espiral",
  "item.minecraft.flow_banner_pattern": "Diseño de estandarte",
  "item.minecraft.flow_banner_pattern.desc": "Estampado de espiral",
  "item.minecraft.flow_banner_pattern.new": "Estampado de espiral",
  "item.minecraft.flow_pottery_sherd": "Fragmento de cerámica de espiral",
  "item.minecraft.flower_banner_pattern": "Diseño de estandarte",
  "item.minecraft.flower_banner_pattern.desc": "Flor",
  "item.minecraft.flower_banner_pattern.new": "Estampado de flor",
  "item.minecraft.flower_pot": "Maceta",
  "item.minecraft.fox_spawn_egg": "Generar zorro",
  "item.minecraft.friend_pottery_shard": "Fragmento de cerámica de amistad",
  "item.minecraft.friend_pottery_sherd": "Fragmento de cerámica de amistad",
  "item.minecraft.frog_spawn_egg": "Generar rana",
  "item.minecraft.furnace_minecart": "Carrito con horno",
  "item.minecraft.ghast_spawn_egg": "Generar ghast",
  "item.minecraft.ghast_tear": "Lágrima de ghast",
  "item.minecraft.glass_bottle": "Botella",
  "item.minecraft.glistering_melon_slice": "Pedazo de sandía brillante",
  "item.minecraft.globe_banner_pattern": "Diseño de estandarte",
  "item.minecraft.globe_banner_pattern.desc": "Planeta",
  "item.minecraft.globe_banner_pattern.new": "Estampado de planeta",
  "item.minecraft.glow_berries": "Bayas luminosas",
  "item.minecraft.glow_ink_sac": "Saco de tinta luminoso",
  "item.minecraft.glow_item_frame": "Marco luminoso",
  "item.minecraft.glow_squid_spawn_egg": "Generar calamar luminoso",
  "item.minecraft.glowstone_dust": "Polvo de piedra luminosa",
  "item.minecraft.goat_horn": "Cuerno de cabra",
  "item.minecraft.goat_spawn_egg": "Generar cabra",
  "item.minecraft.gold_ingot": "Lingote de oro",
  "item.minecraft.gold_nugget": "Pepita de oro",
  "item.minecraft.golden_apple": "Manzana dorada",
  "item.minecraft.golden_axe": "Hacha de oro",
  "item.minecraft.golden_boots": "Botas de oro",
  "item.minecraft.golden_carrot": "Zanahoria dorada",
  "item.minecraft.golden_chestplate": "Pechera de oro",
  "item.minecraft.golden_helmet": "Casco de oro",
  "item.minecraft.golden_hoe": "Azada de oro",
  "item.minecraft.golden_horse_armor": "Armadura de oro para caballo",
  "item.minecraft.golden_leggings": "Pantalones de oro",
  "item.minecraft.golden_nautilus_armor": "Armadura de oro para nautilo",
  "item.minecraft.golden_pickaxe": "Pico de oro",
  "item.minecraft.golden_shovel": "Pala de oro",
  "item.minecraft.golden_spear": "Lanza de oro",
  "item.minecraft.golden_sword": "Espada de oro",
  "item.minecraft.gray_bundle": "Bolsa gris",
  "item.minecraft.gray_dye": "Tinte gris",
  "item.minecraft.gray_harness": "Arnés gris",
  "item.minecraft.green_bundle": "Bolsa verde",
  "item.minecraft.green_dye": "Tinte verde",
  "item.minecraft.green_harness": "Arnés verde",
  "item.minecraft.guardian_spawn_egg": "Generar guardián",
  "item.minecraft.gunpowder": "Pólvora",
  "item.minecraft.guster_banner_pattern": "Diseño de estandarte",
  "item.minecraft.guster_banner_pattern.desc": "Breeze",
  "item.minecraft.guster_banner_pattern.new": "Estampado de breeze",
  "item.minecraft.guster_pottery_sherd": "Fragmento de cerámica de breeze",
  "item.minecraft.happy_ghast_spawn_egg": "Generar ghast feliz",
  "item.minecraft.harness": "Arnés",
  "item.minecraft.heart_of_the_sea": "Corazón del mar",
  "item.minecraft.heart_pottery_shard": "Fragmento de cerámica de corazón",
  "item.minecraft.heart_pottery_sherd": "Fragmento de cerámica de corazón",
  "item.minecraft.heartbreak_pottery_shard": "Fragmento de cerámica de corazón roto",
  "item.minecraft.heartbreak_pottery_sherd": "Fragmento de cerámica de corazón roto",
  "item.minecraft.hoglin_spawn_egg": "Generar hoglin",
  "item.minecraft.honey_bottle": "Botella de miel",
  "item.minecraft.honeycomb": "Panal",
  "item.minecraft.hopper_minecart": "Carrito con tolva",
  "item.minecraft.horse_spawn_egg": "Generar caballo",
  "item.minecraft.host_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.host_armor_trim_smithing_template.new": "Adorno de anfitrión",
  "item.minecraft.howl_pottery_shard": "Fragmento de cerámica de lobo",
  "item.minecraft.howl_pottery_sherd": "Fragmento de cerámica de lobo",
  "item.minecraft.husk_spawn_egg": "Generar zombi momificado (Husk)",
  "item.minecraft.ink_sac": "Saco de tinta",
  "item.minecraft.iron_axe": "Hacha de hierro",
  "item.minecraft.iron_boots": "Botas de hierro",
  "item.minecraft.iron_chestplate": "Pechera de hierro",
  "item.minecraft.iron_golem_spawn_egg": "Generar gólem de hierro",
  "item.minecraft.iron_helmet": "Casco de hierro",
  "item.minecraft.iron_hoe": "Azada de hierro",
  "item.minecraft.iron_horse_armor": "Armadura de hierro para caballo",
  "item.minecraft.iron_ingot": "Lingote de hierro",
  "item.minecraft.iron_leggings": "Pantalones de hierro",
  "item.minecraft.iron_nautilus_armor": "Armadura de hierro para nautilo",
  "item.minecraft.iron_nugget": "Pepita de hierro",
  "item.minecraft.iron_pickaxe": "Pico de hierro",
  "item.minecraft.iron_shovel": "Pala de hierro",
  "item.minecraft.iron_spear": "Lanza de hierro",
  "item.minecraft.iron_sword": "Espada de hierro",
  "item.minecraft.item_frame": "Marco",
  "item.minecraft.jungle_boat": "Bote de jungla",
  "item.minecraft.jungle_chest_boat": "Bote de jungla con baúl",
  "item.minecraft.knowledge_book": "Enciclopedia",
  "item.minecraft.lapis_lazuli": "Lapislázuli",
  "item.minecraft.lava_bucket": "Balde de lava",
  "item.minecraft.lead": "Rienda",
  "item.minecraft.leather": "Cuero",
  "item.minecraft.leather_boots": "Botas de cuero",
  "item.minecraft.leather_chestplate": "Túnica de cuero",
  "item.minecraft.leather_helmet": "Gorra de cuero",
  "item.minecraft.leather_horse_armor": "Armadura de cuero para caballo",
  "item.minecraft.leather_leggings": "Pantalones de cuero",
  "item.minecraft.light_blue_bundle": "Bolsa celeste",
  "item.minecraft.light_blue_dye": "Tinte celeste",
  "item.minecraft.light_blue_harness": "Arnés celeste",
  "item.minecraft.light_gray_bundle": "Bolsa gris claro",
  "item.minecraft.light_gray_dye": "Tinte gris claro",
  "item.minecraft.light_gray_harness": "Arnés gris claro",
  "item.minecraft.lime_bundle": "Bolsa verde lima",
  "item.minecraft.lime_dye": "Tinte verde lima",
  "item.minecraft.lime_harness": "Arnés verde lima",
  "item.minecraft.lingering_potion": "Poción persistente",
  "item.minecraft.lingering_potion.effect.awkward": "Poción persistente rara",
  "item.minecraft.lingering_potion.effect.empty": "Poción persistente no fabricable",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Poción persistente de resistencia al fuego",
  "item.minecraft.lingering_potion.effect.harming": "Poción persistente de daño",
  "item.minecraft.lingering_potion.effect.healing": "Poción persistente de curación",
  "item.minecraft.lingering_potion.effect.infested": "Poción persistente de infestación",
  "item.minecraft.lingering_potion.effect.invisibility": "Poción persistente de invisibilidad",
  "item.minecraft.lingering_potion.effect.leaping": "Poción persistente de salto",
  "item.minecraft.lingering_potion.effect.levitation": "Poción persistente de levitación",
  "item.minecraft.lingering_potion.effect.luck": "Poción persistente de suerte",
  "item.minecraft.lingering_potion.effect.mundane": "Poción persistente mundana",
  "item.minecraft.lingering_potion.effect.night_vision": "Poción persistente de visión nocturna",
  "item.minecraft.lingering_potion.effect.oozing": "Poción persistente de mucosidad",
  "item.minecraft.lingering_potion.effect.poison": "Poción persistente de veneno",
  "item.minecraft.lingering_potion.effect.regeneration": "Poción persistente de regeneración",
  "item.minecraft.lingering_potion.effect.slow_falling": "Poción persistente de caída lenta",
  "item.minecraft.lingering_potion.effect.slowness": "Poción persistente de lentitud",
  "item.minecraft.lingering_potion.effect.strength": "Poción persistente de fuerza",
  "item.minecraft.lingering_potion.effect.swiftness": "Poción persistente de velocidad",
  "item.minecraft.lingering_potion.effect.thick": "Poción persistente espesa",
  "item.minecraft.lingering_potion.effect.turtle_master": "Poción persistente del maestro tortuga",
  "item.minecraft.lingering_potion.effect.water": "Botella de agua persistente",
  "item.minecraft.lingering_potion.effect.water_breathing": "Poción persistente de respiración acuática",
  "item.minecraft.lingering_potion.effect.weakness": "Poción persistente de debilidad",
  "item.minecraft.lingering_potion.effect.weaving": "Poción persistente de tejedura",
  "item.minecraft.lingering_potion.effect.wind_charged": "Poción persistente de carga ventosa",
  "item.minecraft.llama_spawn_egg": "Generar llama",
  "item.minecraft.lodestone_compass": "Brújula magnetizada",
  "item.minecraft.mace": "Maza",
  "item.minecraft.magenta_bundle": "Bolsa magenta",
  "item.minecraft.magenta_dye": "Tinte magenta",
  "item.minecraft.magenta_harness": "Arnés magenta",
  "item.minecraft.magma_cream": "Crema de magma",
  "item.minecraft.magma_cube_spawn_egg": "Generar cubo de magma",
  "item.minecraft.mangrove_boat": "Bote de mangle",
  "item.minecraft.mangrove_chest_boat": "Bote de mangle con baúl",
  "item.minecraft.map": "Mapa en blanco",
  "item.minecraft.melon_seeds": "Semillas de sandía",
  "item.minecraft.melon_slice": "Pedazo de sandía",
  "item.minecraft.milk_bucket": "Balde de leche",
  "item.minecraft.minecart": "Carrito",
  "item.minecraft.miner_pottery_shard": "Fragmento de cerámica de minero",
  "item.minecraft.miner_pottery_sherd": "Fragmento de cerámica de minero",
  "item.minecraft.mojang_banner_pattern": "Diseño de estandarte",
  "item.minecraft.mojang_banner_pattern.desc": "Logotipo",
  "item.minecraft.mojang_banner_pattern.new": "Estampado de Mojang",
  "item.minecraft.mooshroom_spawn_egg": "Generar mooshroom",
  "item.minecraft.mourner_pottery_shard": "Fragmento de cerámica de luto",
  "item.minecraft.mourner_pottery_sherd": "Fragmento de cerámica de doliente",
  "item.minecraft.mule_spawn_egg": "Generar mula",
  "item.minecraft.mushroom_stew": "Guiso de hongos",
  "item.minecraft.music_disc_11": "Disco",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disco",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disco",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disco",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disco",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disco",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disco",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Disco",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (caja de música)",
  "item.minecraft.music_disc_far": "Disco",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Disco",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Disco",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disco",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disco",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Disco",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disco",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disco",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disco",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disco",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disco",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Disco",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disco",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Cordero crudo",
  "item.minecraft.name_tag": "Etiqueta",
  "item.minecraft.nautilus_shell": "Caparazón de nautilo",
  "item.minecraft.nautilus_spawn_egg": "Generar nautilo",
  "item.minecraft.nether_brick": "Ladrillo del Nether",
  "item.minecraft.nether_star": "Estrella del Nether",
  "item.minecraft.nether_wart": "Verruga del Nether",
  "item.minecraft.netherite_axe": "Hacha de netherita",
  "item.minecraft.netherite_boots": "Botas de netherita",
  "item.minecraft.netherite_chestplate": "Pechera de netherita",
  "item.minecraft.netherite_helmet": "Casco de netherita",
  "item.minecraft.netherite_hoe": "Azada de netherita",
  "item.minecraft.netherite_horse_armor": "Armadura de netherita para caballo",
  "item.minecraft.netherite_ingot": "Lingote de netherita",
  "item.minecraft.netherite_leggings": "Pantalones de netherita",
  "item.minecraft.netherite_nautilus_armor": "Armadura de netherita para nautilo",
  "item.minecraft.netherite_pickaxe": "Pico de netherita",
  "item.minecraft.netherite_scrap": "Fragmento de netherita",
  "item.minecraft.netherite_shovel": "Pala de netherita",
  "item.minecraft.netherite_spear": "Lanza de netherita",
  "item.minecraft.netherite_sword": "Espada de netherita",
  "item.minecraft.netherite_upgrade_smithing_template": "Molde de herrería",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Mejora de netherita",
  "item.minecraft.oak_boat": "Bote de roble",
  "item.minecraft.oak_chest_boat": "Bote de roble con baúl",
  "item.minecraft.ocelot_spawn_egg": "Generar ocelote",
  "item.minecraft.ominous_bottle": "Botella siniestra",
  "item.minecraft.ominous_trial_key": "Llave de desafío siniestra",
  "item.minecraft.orange_bundle": "Bolsa naranja",
  "item.minecraft.orange_dye": "Tinte naranja",
  "item.minecraft.orange_harness": "Arnés naranja",
  "item.minecraft.painting": "Cuadro",
  "item.minecraft.pale_oak_boat": "Bote de roble pálido",
  "item.minecraft.pale_oak_chest_boat": "Bote de roble pálido con baúl",
  "item.minecraft.panda_spawn_egg": "Generar panda",
  "item.minecraft.paper": "Papel",
  "item.minecraft.parched_spawn_egg": "Generar esqueleto momificado",
  "item.minecraft.parrot_spawn_egg": "Generar loro",
  "item.minecraft.phantom_membrane": "Membrana de phantom",
  "item.minecraft.phantom_spawn_egg": "Generar phantom",
  "item.minecraft.pig_spawn_egg": "Generar chancho",
  "item.minecraft.piglin_banner_pattern": "Diseño de estandarte",
  "item.minecraft.piglin_banner_pattern.desc": "Hocico",
  "item.minecraft.piglin_banner_pattern.new": "Estampado de hocico",
  "item.minecraft.piglin_brute_spawn_egg": "Generar piglin bruto",
  "item.minecraft.piglin_spawn_egg": "Generar piglin",
  "item.minecraft.pillager_spawn_egg": "Generar saqueador",
  "item.minecraft.pink_bundle": "Bolsa rosa",
  "item.minecraft.pink_dye": "Tinte rosa",
  "item.minecraft.pink_harness": "Arnés rosa",
  "item.minecraft.pitcher_plant": "Planta jarra",
  "item.minecraft.pitcher_pod": "Vaina de planta jarra",
  "item.minecraft.plenty_pottery_shard": "Fragmento de cerámica de baúl",
  "item.minecraft.plenty_pottery_sherd": "Fragmento de cerámica de riqueza",
  "item.minecraft.poisonous_potato": "Papa venenosa",
  "item.minecraft.polar_bear_spawn_egg": "Generar oso polar",
  "item.minecraft.popped_chorus_fruit": "Fruta de chorus horneada",
  "item.minecraft.porkchop": "Chuleta cruda",
  "item.minecraft.potato": "Papa",
  "item.minecraft.potion": "Poción",
  "item.minecraft.potion.effect.awkward": "Poción rara",
  "item.minecraft.potion.effect.empty": "Poción no fabricable",
  "item.minecraft.potion.effect.fire_resistance": "Poción de resistencia al fuego",
  "item.minecraft.potion.effect.harming": "Poción de daño",
  "item.minecraft.potion.effect.healing": "Poción de curación",
  "item.minecraft.potion.effect.infested": "Poción de infestación",
  "item.minecraft.potion.effect.invisibility": "Poción de invisibilidad",
  "item.minecraft.potion.effect.leaping": "Poción de salto",
  "item.minecraft.potion.effect.levitation": "Poción de levitación",
  "item.minecraft.potion.effect.luck": "Poción de suerte",
  "item.minecraft.potion.effect.mundane": "Poción mundana",
  "item.minecraft.potion.effect.night_vision": "Poción de visión nocturna",
  "item.minecraft.potion.effect.oozing": "Poción de mucosidad",
  "item.minecraft.potion.effect.poison": "Poción de veneno",
  "item.minecraft.potion.effect.regeneration": "Poción de regeneración",
  "item.minecraft.potion.effect.slow_falling": "Poción de caída lenta",
  "item.minecraft.potion.effect.slowness": "Poción de lentitud",
  "item.minecraft.potion.effect.strength": "Poción de fuerza",
  "item.minecraft.potion.effect.swiftness": "Poción de velocidad",
  "item.minecraft.potion.effect.thick": "Poción espesa",
  "item.minecraft.potion.effect.turtle_master": "Poción del maestro tortuga",
  "item.minecraft.potion.effect.water": "Botella de agua",
  "item.minecraft.potion.effect.water_breathing": "Poción de respiración acuática",
  "item.minecraft.potion.effect.weakness": "Poción de debilidad",
  "item.minecraft.potion.effect.weaving": "Poción de tejedura",
  "item.minecraft.potion.effect.wind_charged": "Poción de carga ventosa",
  "item.minecraft.pottery_shard_archer": "Fragmento de cerámica de arquero",
  "item.minecraft.pottery_shard_arms_up": "Fragmento de cerámica de brazos arriba",
  "item.minecraft.pottery_shard_prize": "Fragmento de cerámica de joya",
  "item.minecraft.pottery_shard_skull": "Fragmento de cerámica de calavera",
  "item.minecraft.powder_snow_bucket": "Balde de nieve polvo",
  "item.minecraft.prismarine_crystals": "Cristales de prismarina",
  "item.minecraft.prismarine_shard": "Fragmento de prismarina",
  "item.minecraft.prize_pottery_shard": "Fragmento de cerámica de joya",
  "item.minecraft.prize_pottery_sherd": "Fragmento de cerámica de tesoro",
  "item.minecraft.pufferfish": "Pez globo",
  "item.minecraft.pufferfish_bucket": "Balde con pez globo",
  "item.minecraft.pufferfish_spawn_egg": "Generar pez globo",
  "item.minecraft.pumpkin_pie": "Torta de zapallo",
  "item.minecraft.pumpkin_seeds": "Semillas de zapallo",
  "item.minecraft.purple_bundle": "Bolsa violeta",
  "item.minecraft.purple_dye": "Tinte violeta",
  "item.minecraft.purple_harness": "Arnés violeta",
  "item.minecraft.quartz": "Cuarzo del Nether",
  "item.minecraft.rabbit": "Conejo crudo",
  "item.minecraft.rabbit_foot": "Pata de conejo",
  "item.minecraft.rabbit_hide": "Piel de conejo",
  "item.minecraft.rabbit_spawn_egg": "Generar conejo",
  "item.minecraft.rabbit_stew": "Guiso de conejo",
  "item.minecraft.raiser_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Adorno de elevación",
  "item.minecraft.ravager_spawn_egg": "Generar devastador",
  "item.minecraft.raw_copper": "Cobre crudo",
  "item.minecraft.raw_gold": "Oro crudo",
  "item.minecraft.raw_iron": "Hierro crudo",
  "item.minecraft.recovery_compass": "Brújula de recuperación",
  "item.minecraft.red_bundle": "Bolsa roja",
  "item.minecraft.red_dye": "Tinte rojo",
  "item.minecraft.red_harness": "Arnés rojo",
  "item.minecraft.redstone": "Polvo de redstone",
  "item.minecraft.resin_brick": "Ladrillo de resina",
  "item.minecraft.resin_clump": "Grumo de resina",
  "item.minecraft.rib_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Adorno de costillas",
  "item.minecraft.rotten_flesh": "Carne podrida",
  "item.minecraft.saddle": "Montura",
  "item.minecraft.salmon": "Salmón crudo",
  "item.minecraft.salmon_bucket": "Balde con salmón",
  "item.minecraft.salmon_spawn_egg": "Generar salmón",
  "item.minecraft.scrape_pottery_sherd": "Fragmento de cerámica de hacha",
  "item.minecraft.scute": "Escama",
  "item.minecraft.sentry_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Adorno de centinela",
  "item.minecraft.shaper_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Adorno de modelador",
  "item.minecraft.sheaf_pottery_shard": "Fragmento de cerámica de trigo",
  "item.minecraft.sheaf_pottery_sherd": "Fragmento de cerámica de trigo",
  "item.minecraft.shears": "Tijeras",
  "item.minecraft.sheep_spawn_egg": "Generar oveja",
  "item.minecraft.shelter_pottery_shard": "Fragmento de cerámica de refugio",
  "item.minecraft.shelter_pottery_sherd": "Fragmento de cerámica de refugio",
  "item.minecraft.shield": "Escudo",
  "item.minecraft.shield.black": "Escudo negro",
  "item.minecraft.shield.blue": "Escudo azul",
  "item.minecraft.shield.brown": "Escudo marrón",
  "item.minecraft.shield.cyan": "Escudo cian",
  "item.minecraft.shield.gray": "Escudo gris",
  "item.minecraft.shield.green": "Escudo verde",
  "item.minecraft.shield.light_blue": "Escudo celeste",
  "item.minecraft.shield.light_gray": "Escudo gris claro",
  "item.minecraft.shield.lime": "Escudo verde lima",
  "item.minecraft.shield.magenta": "Escudo magenta",
  "item.minecraft.shield.orange": "Escudo naranja",
  "item.minecraft.shield.pink": "Escudo rosa",
  "item.minecraft.shield.purple": "Escudo violeta",
  "item.minecraft.shield.red": "Escudo rojo",
  "item.minecraft.shield.white": "Escudo blanco",
  "item.minecraft.shield.yellow": "Escudo amarillo",
  "item.minecraft.shulker_shell": "Caparazón de shulker",
  "item.minecraft.shulker_spawn_egg": "Generar shulker",
  "item.minecraft.sign": "Cartel",
  "item.minecraft.silence_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Adorno de silencio",
  "item.minecraft.silverfish_spawn_egg": "Generar pez de plata",
  "item.minecraft.skeleton_horse_spawn_egg": "Generar caballo esqueleto",
  "item.minecraft.skeleton_spawn_egg": "Generar esqueleto",
  "item.minecraft.skull_banner_pattern": "Diseño de estandarte",
  "item.minecraft.skull_banner_pattern.desc": "Cráneo",
  "item.minecraft.skull_banner_pattern.new": "Estampado de calavera",
  "item.minecraft.skull_pottery_shard": "Fragmento de cerámica de calavera",
  "item.minecraft.skull_pottery_sherd": "Fragmento de cerámica de calavera",
  "item.minecraft.slime_ball": "Bola de slime",
  "item.minecraft.slime_spawn_egg": "Generar slime",
  "item.minecraft.smithing_template": "Molde de herrería",
  "item.minecraft.smithing_template.applies_to": "Se aplica a:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Colocá un lingote o cristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armaduras",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Colocá una parte de armadura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingotes y cristales",
  "item.minecraft.smithing_template.ingredients": "Ingredientes:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Colocá un lingote de netherita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Equipamiento de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Colocá una armadura, arma o herramienta de diamante",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingote de netherita",
  "item.minecraft.smithing_template.upgrade": "Mejora: ",
  "item.minecraft.sniffer_spawn_egg": "Generar sniffer",
  "item.minecraft.snort_pottery_shard": "Fragmento de cerámica de sniffer",
  "item.minecraft.snort_pottery_sherd": "Fragmento de cerámica de sniffer",
  "item.minecraft.snout_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Adorno de hocico",
  "item.minecraft.snow_golem_spawn_egg": "Generar gólem de nieve",
  "item.minecraft.snowball": "Bola de nieve",
  "item.minecraft.spectral_arrow": "Flecha espectral",
  "item.minecraft.spider_eye": "Ojo de araña",
  "item.minecraft.spider_spawn_egg": "Generar araña",
  "item.minecraft.spire_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Adorno de agujas",
  "item.minecraft.splash_potion": "Poción arrojadiza",
  "item.minecraft.splash_potion.effect.awkward": "Poción arrojadiza rara",
  "item.minecraft.splash_potion.effect.empty": "Poción arrojadiza no fabricable",
  "item.minecraft.splash_potion.effect.fire_resistance": "Poción arrojadiza de resistencia al fuego",
  "item.minecraft.splash_potion.effect.harming": "Poción arrojadiza de daño",
  "item.minecraft.splash_potion.effect.healing": "Poción arrojadiza de curación",
  "item.minecraft.splash_potion.effect.infested": "Poción arrojadiza de infestación",
  "item.minecraft.splash_potion.effect.invisibility": "Poción arrojadiza de invisibilidad",
  "item.minecraft.splash_potion.effect.leaping": "Poción arrojadiza de salto",
  "item.minecraft.splash_potion.effect.levitation": "Poción arrojadiza de levitación",
  "item.minecraft.splash_potion.effect.luck": "Poción arrojadiza de suerte",
  "item.minecraft.splash_potion.effect.mundane": "Poción arrojadiza mundana",
  "item.minecraft.splash_potion.effect.night_vision": "Poción arrojadiza de visión nocturna",
  "item.minecraft.splash_potion.effect.oozing": "Poción arrojadiza de mucosidad",
  "item.minecraft.splash_potion.effect.poison": "Poción arrojadiza de veneno",
  "item.minecraft.splash_potion.effect.regeneration": "Poción arrojadiza de regeneración",
  "item.minecraft.splash_potion.effect.slow_falling": "Poción arrojadiza de caída lenta",
  "item.minecraft.splash_potion.effect.slowness": "Poción arrojadiza de lentitud",
  "item.minecraft.splash_potion.effect.strength": "Poción arrojadiza de fuerza",
  "item.minecraft.splash_potion.effect.swiftness": "Poción arrojadiza de velocidad",
  "item.minecraft.splash_potion.effect.thick": "Poción arrojadiza espesa",
  "item.minecraft.splash_potion.effect.turtle_master": "Poción arrojadiza del maestro tortuga",
  "item.minecraft.splash_potion.effect.water": "Botella de agua arrojadiza",
  "item.minecraft.splash_potion.effect.water_breathing": "Poción arrojadiza de respiración acuática",
  "item.minecraft.splash_potion.effect.weakness": "Poción arrojadiza de debilidad",
  "item.minecraft.splash_potion.effect.weaving": "Poción arrojadiza de tejedura",
  "item.minecraft.splash_potion.effect.wind_charged": "Poción arrojadiza de carga ventosa",
  "item.minecraft.spruce_boat": "Bote de pino",
  "item.minecraft.spruce_chest_boat": "Bote de abeto con baúl",
  "item.minecraft.spyglass": "Catalejo",
  "item.minecraft.squid_spawn_egg": "Generar calamar",
  "item.minecraft.stick": "Palo",
  "item.minecraft.stone_axe": "Hacha de piedra",
  "item.minecraft.stone_hoe": "Azada de piedra",
  "item.minecraft.stone_pickaxe": "Pico de piedra",
  "item.minecraft.stone_shovel": "Pala de piedra",
  "item.minecraft.stone_spear": "Lanza de piedra",
  "item.minecraft.stone_sword": "Espada de piedra",
  "item.minecraft.stray_spawn_egg": "Generar esqueleto glacial (Stray)",
  "item.minecraft.strider_spawn_egg": "Generar strider",
  "item.minecraft.string": "Hilo",
  "item.minecraft.sugar": "Azúcar",
  "item.minecraft.suspicious_stew": "Guiso sospechoso",
  "item.minecraft.sweet_berries": "Bayas dulces",
  "item.minecraft.tadpole_bucket": "Balde con renacuajo",
  "item.minecraft.tadpole_spawn_egg": "Generar renacuajo",
  "item.minecraft.tide_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Adorno de la marea",
  "item.minecraft.tipped_arrow": "Flecha con efecto",
  "item.minecraft.tipped_arrow.effect.awkward": "Flecha con efecto",
  "item.minecraft.tipped_arrow.effect.empty": "Flecha con efecto no fabricable",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Flecha de resistencia al fuego",
  "item.minecraft.tipped_arrow.effect.harming": "Flecha de daño",
  "item.minecraft.tipped_arrow.effect.healing": "Flecha de curación",
  "item.minecraft.tipped_arrow.effect.infested": "Flecha de infestación",
  "item.minecraft.tipped_arrow.effect.invisibility": "Flecha de invisibilidad",
  "item.minecraft.tipped_arrow.effect.leaping": "Flecha de salto",
  "item.minecraft.tipped_arrow.effect.levitation": "Flecha de levitación",
  "item.minecraft.tipped_arrow.effect.luck": "Flecha de suerte",
  "item.minecraft.tipped_arrow.effect.mundane": "Flecha con efecto",
  "item.minecraft.tipped_arrow.effect.night_vision": "Flecha de visión nocturna",
  "item.minecraft.tipped_arrow.effect.oozing": "Flecha de mucosidad",
  "item.minecraft.tipped_arrow.effect.poison": "Flecha de veneno",
  "item.minecraft.tipped_arrow.effect.regeneration": "Flecha de regeneración",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Flecha de caída lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Flecha de lentitud",
  "item.minecraft.tipped_arrow.effect.strength": "Flecha de fuerza",
  "item.minecraft.tipped_arrow.effect.swiftness": "Flecha de velocidad",
  "item.minecraft.tipped_arrow.effect.thick": "Flecha con efecto",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Flecha del maestro tortuga",
  "item.minecraft.tipped_arrow.effect.water": "Flecha con salpicadura",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Flecha de respiración acuática",
  "item.minecraft.tipped_arrow.effect.weakness": "Flecha de debilidad",
  "item.minecraft.tipped_arrow.effect.weaving": "Flecha de tejedura",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Flecha de carga ventosa",
  "item.minecraft.tnt_minecart": "Carrito con TNT",
  "item.minecraft.torchflower_seeds": "Semillas de anflorcha",
  "item.minecraft.totem_of_undying": "Tótem de inmortalidad",
  "item.minecraft.trader_llama_spawn_egg": "Generar llama de comerciante",
  "item.minecraft.trial_key": "Llave de desafío",
  "item.minecraft.trident": "Tridente",
  "item.minecraft.tropical_fish": "Pez tropical",
  "item.minecraft.tropical_fish_bucket": "Balde con pez tropical",
  "item.minecraft.tropical_fish_spawn_egg": "Generar pez tropical",
  "item.minecraft.turtle_helmet": "Caparazón de tortuga",
  "item.minecraft.turtle_scute": "Escama de tortuga",
  "item.minecraft.turtle_spawn_egg": "Generar tortuga",
  "item.minecraft.vex_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Adorno de vex",
  "item.minecraft.vex_spawn_egg": "Generar vex",
  "item.minecraft.villager_spawn_egg": "Generar aldeano",
  "item.minecraft.vindicator_spawn_egg": "Generar vindicador",
  "item.minecraft.wandering_trader_spawn_egg": "Generar comerciante nómada",
  "item.minecraft.ward_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Adorno de warden",
  "item.minecraft.warden_spawn_egg": "Generar warden",
  "item.minecraft.warped_fungus_on_a_stick": "Caña con hongo distorsionado",
  "item.minecraft.water_bucket": "Balde de agua",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Adorno de guía",
  "item.minecraft.wheat": "Trigo",
  "item.minecraft.wheat_seeds": "Semillas de trigo",
  "item.minecraft.white_bundle": "Bolsa blanca",
  "item.minecraft.white_dye": "Tinte blanco",
  "item.minecraft.white_harness": "Arnés blanco",
  "item.minecraft.wild_armor_trim_smithing_template": "Molde de herrería",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Adorno de jungla",
  "item.minecraft.wind_charge": "Carga ventosa",
  "item.minecraft.witch_spawn_egg": "Generar bruja",
  "item.minecraft.wither_skeleton_spawn_egg": "Generar esqueleto del Wither",
  "item.minecraft.wither_spawn_egg": "Generar Wither",
  "item.minecraft.wolf_armor": "Armadura para lobo",
  "item.minecraft.wolf_spawn_egg": "Generar lobo",
  "item.minecraft.wooden_axe": "Hacha de madera",
  "item.minecraft.wooden_hoe": "Azada de madera",
  "item.minecraft.wooden_pickaxe": "Pico de madera",
  "item.minecraft.wooden_shovel": "Pala de madera",
  "item.minecraft.wooden_spear": "Lanza de madera",
  "item.minecraft.wooden_sword": "Espada de madera",
  "item.minecraft.writable_book": "Libro y pluma",
  "item.minecraft.written_book": "Libro escrito",
  "item.minecraft.yellow_bundle": "Bolsa amarilla",
  "item.minecraft.yellow_dye": "Tinte amarillo",
  "item.minecraft.yellow_harness": "Arnés amarillo",
  "item.minecraft.zoglin_spawn_egg": "Generar zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Generar caballo zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Generar nautilo zombi",
  "item.minecraft.zombie_spawn_egg": "Generar zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Generar aldeano zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Generar piglin zombificado"
}
export const es_uy = items; 
